var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 424.456,
    height: 415.564,
    viewBox: "0 0 424.456 415.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.008,
    y1: 0.075,
    x2: 0.992,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4083f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#628fde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#3476ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#548ded"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5993",
    "data-name": "Group 5993",
    transform: "translate(-37.331 -42.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5539",
    "data-name": "Group 5539"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5518",
    "data-name": "Group 5518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5517",
    "data-name": "Group 5517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5516",
    "data-name": "Group 5516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M393.979,456.242c-17.832-8.974-24.543-29.447-26.631-48.42-.349-3.167-1.175-6.439-.076-9.421s4.325-5.377,7.338-4.457c2.5.763,3.913,3.338,5.548,5.4a18.636,18.636,0,0,0,8.412,5.992c2.158.751,4.732,1.029,6.556-.35,2.5-1.893,2.279-5.7,1.806-8.827l-2.643-17.51a29.531,29.531,0,0,1-.4-9.446c.544-3.116,2.3-6.191,5.16-7.457s6.8-.08,7.87,2.9a29.187,29.187,0,0,1,.654,3.89c.275,1.289,1.089,2.641,2.377,2.824,1.3.187,2.43-.883,3.234-1.936,2.778-3.632,4.384-8.027,5.85-12.378s2.857-8.79,5.294-12.666,6.1-7.2,10.553-8.1,9.636,1.177,11.408,5.419-.154,9.111-2.442,13.094a70.706,70.706,0,0,1-12.561,15.992,5.818,5.818,0,0,0-2.058,2.972c-.379,2.188,1.9,3.977,4.064,4.366,2.449.441,4.949-.169,7.434-.234s5.29.63,6.548,2.806c1.747,3.018-.447,6.763-2.765,9.344a60.572,60.572,0,0,1-16.259,12.8c-2.184,1.177-4.5,2.268-6.128,4.156s-2.34,4.869-.9,6.914,4.429,2.338,6.779,1.54,4.323-2.42,6.5-3.621c4.072-2.249,9.678-2.756,12.975.568a10.022,10.022,0,0,1,2.324,8.619,23.107,23.107,0,0,1-3.632,8.433,60.887,60.887,0,0,1-23.121,21.806c-9.491,4.909-18.614,7.185-29.07,4.989",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5522",
    "data-name": "Group 5522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5521",
    "data-name": "Group 5521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5520",
    "data-name": "Group 5520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5519",
    "data-name": "Group 5519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M397.142,443.7a283.9,283.9,0,0,1,6.778-31.851q1.117-4.182,2.2-8.258c.731-2.708,1.454-5.394,2.325-7.978a141.76,141.76,0,0,1,5.852-14.558c2.085-4.541,4.23-8.774,6.263-12.717s4.018-7.578,5.958-10.816a112.384,112.384,0,0,1,10.283-14.584c1.344-1.621,2.428-2.844,3.174-3.663.36-.389.642-.7.854-.926a2.245,2.245,0,0,1,.306-.3,2.312,2.312,0,0,1-.261.342c-.2.239-.471.558-.811.964-.716.844-1.772,2.09-3.088,3.731a118.78,118.78,0,0,0-10.1,14.653c-1.913,3.242-3.861,6.882-5.882,10.826s-4.139,8.185-6.206,12.721a143.2,143.2,0,0,0-5.8,14.514c-.862,2.57-1.577,5.233-2.307,7.949s-1.458,5.467-2.2,8.254a290.892,290.892,0,0,0-6.81,31.778",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5526",
    "data-name": "Group 5526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5525",
    "data-name": "Group 5525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5524",
    "data-name": "Group 5524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5523",
    "data-name": "Group 5523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M408.611,395.569a6.513,6.513,0,0,1-.5-1.293c-.29-.842-.669-2.074-1.115-3.6-.894-3.056-1.985-7.32-3.17-12.025s-2.334-8.944-3.272-11.978c-.465-1.519-.854-2.745-1.133-3.588a6.333,6.333,0,0,1-.372-1.335,6.351,6.351,0,0,1,.584,1.256c.345.822.795,2.031,1.311,3.538,1.043,3.013,2.259,7.25,3.445,11.962,1.158,4.646,2.2,8.849,3,12.061l.935,3.648A6.232,6.232,0,0,1,408.611,395.569Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5530",
    "data-name": "Group 5530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5529",
    "data-name": "Group 5529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5528",
    "data-name": "Group 5528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5527",
    "data-name": "Group 5527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M447.822,382.212a8.8,8.8,0,0,1-1.579.425c-1.021.242-2.5.583-4.313,1.063-3.634.932-8.608,2.395-14.025,4.25s-10.244,3.761-13.7,5.233c-1.733.724-3.119,1.348-4.08,1.773a8.725,8.725,0,0,1-1.517.613,8.826,8.826,0,0,1,1.419-.821c.933-.489,2.3-1.172,4.013-1.948,3.42-1.574,8.242-3.538,13.674-5.409a143.487,143.487,0,0,1,14.115-4.1c1.832-.431,3.329-.712,4.367-.884A8.55,8.55,0,0,1,447.822,382.212Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5534",
    "data-name": "Group 5534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5533",
    "data-name": "Group 5533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5532",
    "data-name": "Group 5532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5531",
    "data-name": "Group 5531"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M397.531,442.889a2.1,2.1,0,0,1-.348-.452l-.9-1.358c-.776-1.183-1.855-2.924-3.159-5.093-2.611-4.335-6.03-10.438-9.712-17.222s-7.042-12.914-9.559-17.3l-3-5.184-.808-1.415a2.15,2.15,0,0,1-.248-.515,2.1,2.1,0,0,1,.348.452l.9,1.358c.776,1.183,1.854,2.924,3.159,5.092,2.612,4.336,6.03,10.438,9.714,17.226s7.04,12.91,9.557,17.295c1.232,2.129,2.244,3.882,3,5.183l.808,1.416A2.12,2.12,0,0,1,397.531,442.889Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5538",
    "data-name": "Group 5538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5537",
    "data-name": "Group 5537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5536",
    "data-name": "Group 5536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5535",
    "data-name": "Group 5535"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M448.587,417.888a2.155,2.155,0,0,1-.5.3l-1.479.746c-1.37.674-3.218,1.583-5.466,2.687-4.615,2.271-10.953,5.479-17.952,9.034s-13.374,6.71-18.037,8.885c-2.331,1.089-4.226,1.95-5.548,2.519-.612.259-1.116.471-1.526.646a2.21,2.21,0,0,1-.548.188,2.179,2.179,0,0,1,.5-.3l1.48-.745,5.465-2.687c4.615-2.27,10.954-5.479,17.954-9.036s13.372-6.708,18.035-8.883c2.331-1.089,4.226-1.95,5.549-2.519l1.526-.646A2.129,2.129,0,0,1,448.587,417.888Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5541",
    "data-name": "Group 5541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5540",
    "data-name": "Group 5540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M67.867,170.106l-9.8-19.427A27.765,27.765,0,0,0,45.1,164.929a25.738,25.738,0,0,0,2.271,24.033,30.744,30.744,0,0,0,1.86,2.6c.017.021.031.042.047.062l0,0L70.14,174.685Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M89.093,152.091a25.81,25.81,0,0,0-25.542-3.861c-.258.1-.517.2-.776.3-.164.067-.327.129-.491.2q-.717.308-1.435.661l-.065.03,0,0-.06.028,0,0h0l9.8,19.427,2.3,4.566,26.036-6.536.032-.008h0a25.888,25.888,0,0,0-1.987-5.312A28.233,28.233,0,0,0,89.093,152.091Z",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M72.607,176.494,51.745,193.436a26.875,26.875,0,0,0,46.927-23.492L72.637,176.48",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_535",
    "data-name": "Rectangle 535",
    width: 97.44,
    height: 87.176,
    transform: "translate(101.168 115.74)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_536",
    "data-name": "Rectangle 536",
    width: 97.44,
    height: 87.176,
    transform: "translate(92.305 122.372)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5542",
    "data-name": "Group 5542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M392.51,80.278h30.482A30.482,30.482,0,1,1,391.8,49.805Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M400.726,72.847l-.688-30.481A32.152,32.152,0,0,1,421.984,51,31.332,31.332,0,0,1,431.2,72.374Z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5577",
    "data-name": "Group 5577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5558",
    "data-name": "Group 5558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5549",
    "data-name": "Group 5549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5548",
    "data-name": "Group 5548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5543",
    "data-name": "Group 5543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M125.549,277.569a18.523,18.523,0,0,1,3.43-3.525l-.835-4.484,6.929-2.985,2.685,3.686a18.511,18.511,0,0,1,4.918-.071l2.579-3.759,7.011,2.789-.708,4.5a18.5,18.5,0,0,1,3.526,3.43l4.483-.834,2.986,6.928-3.686,2.686a18.5,18.5,0,0,1,.071,4.917l3.758,2.58-2.788,7.01-4.5-.707a18.466,18.466,0,0,1-3.43,3.525l.835,4.484-6.93,2.985-2.685-3.686a18.508,18.508,0,0,1-4.918.071l-2.579,3.759-7.01-2.789.707-4.5a18.47,18.47,0,0,1-3.526-3.43l-4.483.835-2.985-6.929,3.686-2.686a18.5,18.5,0,0,1-.071-4.917l-3.759-2.58,2.789-7.01,4.5.707Zm7.534,7.772a8.094,8.094,0,1,0,10.512-4.529A8.094,8.094,0,0,0,133.083,285.341Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5545",
    "data-name": "Group 5545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5544",
    "data-name": "Group 5544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M133.083,285.341a1.959,1.959,0,0,1,.168-.492,6.407,6.407,0,0,1,.716-1.31,8.053,8.053,0,0,1,4.415-3.172,8.186,8.186,0,0,1,3.814-.186,8.308,8.308,0,0,1,3.938,1.928,8.212,8.212,0,0,1,2.541,4.123,8.287,8.287,0,0,1-3.647,9.171,8.212,8.212,0,0,1-4.68,1.251,8.3,8.3,0,0,1-4.186-1.3,8.173,8.173,0,0,1-2.644-2.755,8.055,8.055,0,0,1-1.03-5.338,6.4,6.4,0,0,1,.379-1.443,1.966,1.966,0,0,1,.216-.473c.059.019-.243.679-.394,1.943a8.064,8.064,0,0,0,1.144,5.121,7.888,7.888,0,0,0,6.53,3.77,7.773,7.773,0,0,0,4.394-1.2,7.819,7.819,0,0,0,3.424-8.609,7.776,7.776,0,0,0-2.365-3.894,7.891,7.891,0,0,0-7.335-1.745,8.068,8.068,0,0,0-4.35,2.936C133.373,284.68,133.139,285.367,133.083,285.341Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5547",
    "data-name": "Group 5547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5546",
    "data-name": "Group 5546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M125.549,277.569a1.422,1.422,0,0,1-.282-.025l-.855-.113-3.379-.487.09-.051c-.7,1.8-1.627,4.168-2.743,7.028l-.048-.157,3.771,2.562.076.051-.011.093a18.46,18.46,0,0,0,.088,4.874l.016.1-.084.061-3.678,2.7.062-.224c.945,2.18,1.949,4.493,3,6.921l-.226-.12,4.481-.844.128-.024.081.1a18.352,18.352,0,0,0,3.49,3.383l.109.08-.021.135c-.217,1.4-.456,2.936-.7,4.5l-.143-.252,7.014,2.779-.289.088,2.574-3.761.085-.124.149.018a18.376,18.376,0,0,0,4.851-.074l.151-.023.09.123,2.688,3.685-.307-.085,6.927-2.988-.152.285-.836-4.483-.029-.155.124-.1a18.257,18.257,0,0,0,3.379-3.473l0,0c.5-.205.139-.057.25-.1h0l.008,0,.018,0,.036.006.071.011.141.022.284.045.566.089,1.129.177,2.245.353-.282.161,2.791-7.01.093.308-3.757-2.581-.128-.088.019-.153a18.251,18.251,0,0,0-.067-4.85l-.022-.151.123-.09,3.688-2.682-.081.3q-1.525-3.549-2.978-6.932l.264.141-4.484.828-.139.026-.087-.111a18.28,18.28,0,0,0-3.477-3.393l-.109-.082.021-.134c.245-1.544.483-3.04.716-4.5l.134.234-7-2.8.238-.073c-.911,1.319-1.765,2.558-2.589,3.752l-.065.093-.112-.013a18.354,18.354,0,0,0-4.87.054l-.1.015-.06-.083-2.671-3.7.185.051-6.944,2.95.069-.128.8,4.49.009.05-.04.031a19.171,19.171,0,0,0-2.689,2.532l-.592.7a1.545,1.545,0,0,1-.2.228,2.182,2.182,0,0,1,.166-.255c.119-.164.3-.411.56-.727a17.729,17.729,0,0,1,2.652-2.609l-.031.081-.867-4.477-.017-.091.086-.038,6.914-3.019.112-.049.074.1c.834,1.137,1.718,2.34,2.7,3.675l-.164-.068a18.637,18.637,0,0,1,4.966-.087l-.177.079,2.569-3.765.089-.132.149.059,7.017,2.773.16.063-.026.172c-.227,1.462-.459,2.959-.7,4.5l-.088-.216a18.736,18.736,0,0,1,3.575,3.467l-.226-.085,4.481-.841.188-.035.077.176,2.992,6.925.079.182-.16.117-3.684,2.689.1-.241a18.714,18.714,0,0,1,.075,4.985l-.109-.241,3.76,2.577.17.116-.076.192q-1.374,3.456-2.786,7.011l-.077.193-.205-.032-2.246-.352-1.129-.178-.566-.089-.283-.044-.142-.022-.071-.012-.036-.005-.017,0h-.013l.249-.1,0,0a18.814,18.814,0,0,1-3.475,3.571l.094-.252c.287,1.539.571,3.067.834,4.483l.038.2-.19.081-6.93,2.982-.188.081-.12-.165-2.682-3.688.24.1a18.816,18.816,0,0,1-4.984.067l.233-.1-2.583,3.756-.11.159-.179-.071-7.007-2.8-.173-.069.03-.183c.248-1.567.493-3.106.714-4.5l.088.215a18.761,18.761,0,0,1-3.561-3.478l.209.079-4.485.824-.162.03-.064-.15c-1.041-2.434-2.033-4.752-2.967-6.937l-.059-.136.12-.087,3.694-2.674-.068.163a18.712,18.712,0,0,1-.054-4.96l.066.144-3.747-2.6-.088-.06.04-.1c1.153-2.846,2.107-5.2,2.833-6.992l.026-.063.065.011,3.331.568.862.156A2.2,2.2,0,0,1,125.549,277.569Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5553",
    "data-name": "Group 5553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5552",
    "data-name": "Group 5552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5551",
    "data-name": "Group 5551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5550",
    "data-name": "Group 5550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M133.083,285.341c.016.015.124-.319.449-.9a8.014,8.014,0,0,1,1.834-2.241,8.076,8.076,0,1,1,4.569,14.226,8.266,8.266,0,0,1-7.562-8.582,8.773,8.773,0,0,1,.158-1.306q.062-.324.145-.644l.087-.317.045-.154.018-.068,0-.019a.121.121,0,0,0,0,.03.26.26,0,0,0,.173.219l.306-.116a5.1,5.1,0,0,0-.372,1,7.672,7.672,0,0,0,.3,4.929,7.943,7.943,0,0,0,3.061,3.709,8.055,8.055,0,0,0,11.578-3.239,8.1,8.1,0,0,0-12.522-9.722,7.887,7.887,0,0,0-1.837,2.264,7.174,7.174,0,0,0-.334.688,1.664,1.664,0,0,1-.1.241.742.742,0,0,1,.054-.259,5.109,5.109,0,0,1,.291-.719,7.572,7.572,0,0,1,1.8-2.368A8.3,8.3,0,0,1,139.473,280,8.413,8.413,0,0,1,145.5,281.4a8.509,8.509,0,0,1,3.631,6.5,8.61,8.61,0,0,1-.836,4.176,8.494,8.494,0,0,1-15.53-.479,8.183,8.183,0,0,1-.328-5.26,5.519,5.519,0,0,1,.426-1.124l.1-.187.207.071a.292.292,0,0,1,.184.256.494.494,0,0,1,0,.071l-.013.06-.023.087-.046.156-.084.3c-.053.2-.1.406-.137.61a8.24,8.24,0,0,0-.15,1.231,7.713,7.713,0,0,0,7.078,8.067,7.677,7.677,0,0,0,5.2-13.8,7.817,7.817,0,0,0-5.587-1.5,8.061,8.061,0,0,0-4.09,1.725,8.454,8.454,0,0,0-1.872,2.14C133.272,285.049,133.128,285.377,133.083,285.341Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5557",
    "data-name": "Group 5557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5556",
    "data-name": "Group 5556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5555",
    "data-name": "Group 5555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5554",
    "data-name": "Group 5554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M125.549,277.569l-4.559-.732.063-.036-2.853,7.15-.034-.112L122,286.474l-.161.135-.059-.128.209-.032a18.6,18.6,0,0,0,.068,4.925l-.235-.03.06-.146.187.148-3.793,2.762.044-.163q1.455,3.377,3.094,7.185l-.167-.089,4.627-.861-.027.308-.186-.07.184-.249a18.585,18.585,0,0,0,3.531,3.435l-.258.2-.078-.191.324-.038c-.222,1.418-.474,3.024-.732,4.665l-.109-.192,7.324,2.912-.225.068,2.676-3.9.24.288-.207.094-.057-.371a18.649,18.649,0,0,0,4.923-.073l-.048.384-.214-.089.241-.305,2.794,3.832-.249-.069,7.263-3.134-.127.237c-.266-1.423-.567-3.034-.871-4.664l.421.038-.084.224-.342-.251a18.545,18.545,0,0,0,3.433-3.536l.261.348-.222.091-.05-.43,4.686.732-.247.141c.9-2.271,1.9-4.8,2.917-7.356l.085.28-3.913-2.678.351-.294.1.214-.453.07a18.572,18.572,0,0,0-.076-4.914l.46.058-.09.214-.364-.288,3.825-2.794-.08.293c-.974-2.249-2.048-4.733-3.134-7.242l.273.145-4.649.873.043-.479.2.076-.285.388a18.574,18.574,0,0,0-3.523-3.415l.383-.3.079.192-.482.057c.224-1.448.472-3.048.721-4.656l.158.275-7.293-2.882.306-.094-2.648,3.883-.319-.38.157-.071.076.491a18.474,18.474,0,0,0-4.891.085l.061-.494.145.061-.308.391-2.763-3.765.312.084-7.092,3.094.151-.288c.278,1.438.578,3,.88,4.559l-.5-.042.027-.072.406.295a17.074,17.074,0,0,0-2.957,3.007l-.21.272c-.008.015-.019.011-.051.006a.215.215,0,0,0-.057,0l-.017,0-.009,0h0c.076.013-.237-.27-.342-.149a.238.238,0,0,0-.054.03l-.018.015.013-.014.45-.537c.3-.364.622-.723.95-1.063a19.358,19.358,0,0,1,2.108-1.89l-.1.251c-.275-1.53-.545-3.035-.814-4.534l.486.077-.061.114-.332-.361,6.943-2.954.033.488-.165-.045.278-.4q1.371,1.895,2.726,3.77l-.246-.1a18.76,18.76,0,0,1,5.135-.058l-.242.109,2.646-3.834.285.39-.211.064.02-.482,7,2.8-.315.361-.119-.209.471-.086q-.371,2.329-.736,4.621l-.1-.242a18.678,18.678,0,0,1,3.7,3.617l-.242-.092,4.608-.849-.071.462-.235-.125.344-.317q1.506,3.513,2.975,6.933l-.46.032.073-.266.379.262-3.8,2.76.1-.23a18.575,18.575,0,0,1,.068,5.192l-.1-.224,3.869,2.662-.357.261-.083-.274.442.019-2.8,7.007-.325-.283.251-.143.077.424-4.639-.733.214-.087a18.625,18.625,0,0,1-3.626,3.719l.081-.214c.3,1.611.58,3.127.857,4.622l-.4-.062c.048-.089.092-.171.135-.253l.275.3-6.93,2.98-.028-.39.274.076-.222.321-2.763-3.8.192.081a18.531,18.531,0,0,1-5.178.072l.184-.083-2.656,3.868-.211-.287.258-.078-.014.355-7.01-2.791.219-.252.128.224-.328.061c.267-1.7.5-3.179.727-4.623l.066.162a18.488,18.488,0,0,1-3.688-3.588l.155.058-4.6.856.043-.281.2.107-.209.193-2.986-6.928.252-.018-.055.2-.207-.143,3.76-2.742-.049.117a18.509,18.509,0,0,1-.077-5.083l.046.1c-1.6-1.1-2.758-1.888-3.828-2.622l.141-.1.042.14-.174-.007c1.21-3.054,2.1-5.3,2.78-7.013l.082.07-.08.046-.02-.106,4.506.69a7.731,7.731,0,0,1-1.121-.112l-3.4-.465-.164-.023.144-.083.08-.046.14-.081-.058.152-2.715,7.039-.1.248-.079-.255-.043-.14-.077-.252.218.148,3.845,2.6.054.037-.007.065a18.382,18.382,0,0,0,.1,5.021l.011.073-.059.044-3.747,2.76-.307.227.1-.37.054-.2.1-.367.152.349c.906,2.078,1.873,4.3,3.016,6.915l.172.395-.381-.2-.2-.107-.379-.2.422-.08,4.594-.874.1-.018.06.076a18.2,18.2,0,0,0,3.638,3.514l.082.06-.015.1c-.223,1.444-.451,2.926-.712,4.625l-.077.5-.251-.439-.128-.224-.25-.437.469.185,7.017,2.77.5.2-.515.158-.258.079-.514.157.3-.444,2.645-3.875.067-.1.117.014a18.208,18.208,0,0,0,5.072-.083l.12-.019.073.1,2.772,3.791.349.477-.571-.156-.273-.074-.57-.155.543-.235,6.924-2.995.564-.244-.289.542-.135.254-.289.543-.113-.605c-.28-1.495-.564-3.009-.866-4.62l-.024-.132.1-.082a18.177,18.177,0,0,0,3.538-3.642l.079-.108.136.021,4.64.725.644.1-.566.324-.251.143-.567.324.241-.607c.909-2.287,1.833-4.615,2.785-7.012l.247-.622.2.64.084.275.195.641-.553-.38-3.873-2.656-.119-.082.018-.142a18.135,18.135,0,0,0-.073-5.066l-.022-.143.119-.087,3.8-2.765.562-.409-.184.671c-.024.087-.047.175-.072.266l-.184.673-.276-.641q-1.472-3.42-2.981-6.93l-.28-.649.624.332.235.126.626.333-.7.129-4.607.854-.15.028-.093-.12a18.177,18.177,0,0,0-3.61-3.52l-.123-.09.024-.152q.365-2.295.732-4.621l.113-.714.359.628.119.209.36.631-.675-.27-7.005-2.8-.677-.27.7-.213.212-.064.7-.214-.417.6-2.645,3.837-.089.128-.154-.019a18.245,18.245,0,0,0-5,.058l-.154.023-.093-.128-2.727-3.768-.431-.6.71.194.165.046.718.2-.685.292-6.942,2.955-.678.289.347-.651.061-.114.353-.661.132.738c.269,1.5.54,3,.814,4.533l.028.155-.124.1a18.874,18.874,0,0,0-2.053,1.84c-.322.335-.629.676-.927,1.038l-.458.545-.047.051-.027.022a.262.262,0,0,1-.059.033c-.105.121-.42-.162-.344-.149v0l0-.016.008-.035a1.37,1.37,0,0,1,.04-.148,1.148,1.148,0,0,1,.144-.289l.222-.288a17.573,17.573,0,0,1,3.047-3.1l.74-.594-.334.889-.027.072-.324.864-.175-.906c-.3-1.564-.6-3.122-.879-4.559l-.04-.205.191-.083,7.093-3.092.19-.083.123.167c.949,1.295,1.9,2.585,2.762,3.766l.551.752-.859-.36-.146-.061-.847-.355.908-.139a19.007,19.007,0,0,1,5.029-.086l.92.109-.844.381-.157.071-.836.378.518-.757,2.65-3.882.116-.169.19.076,7.29,2.885.189.075-.031.2-.725,4.655-.14.9-.343-.84-.078-.192-.34-.831.723.533a19.008,19.008,0,0,1,3.616,3.511l.554.705-.839-.317-.2-.075-.835-.316L155,276.7l4.65-.869.2-.037.078.182c1.084,2.511,2.155,4.995,3.126,7.246l.078.179-.158.115-3.828,2.79-.7.51.336-.8.09-.214.332-.793.128.85a19.022,19.022,0,0,1,.073,5.042l-.1.844-.35-.775-.1-.214-.351-.776.7.482,3.909,2.683.155.107-.07.174-2.928,7.351-.067.17-.181-.029-4.685-.739-.795-.126.745-.3.222-.091.742-.3-.481.65a19,19,0,0,1-3.513,3.6l-.619.483.277-.733c.03-.079.059-.157.085-.224l.278-.737.144.774c.3,1.63.6,3.242.862,4.665l.032.17-.158.067-7.269,3.119-.153.066-.1-.134-2.785-3.837-.424-.585.665.28.214.09.663.279-.711.106a19.009,19.009,0,0,1-5.03.062l-.691-.085.634-.286.208-.094.638-.288-.4.576-2.686,3.9-.086.124-.139-.056-7.317-2.933-.132-.052.023-.14.747-4.663.1-.6.229.561.078.192.229.563-.487-.363a18.924,18.924,0,0,1-3.583-3.509l-.351-.452.535.2.185.07.54.2-.568.1-4.63.844-.119.022-.048-.112-3.063-7.2-.043-.1.088-.063,3.807-2.743.358-.258-.172.406-.061.145-.173.41-.063-.44a18.769,18.769,0,0,1-.042-4.987l.049-.387.16.355.057.129.162.36-.323-.225-3.817-2.661L118,283.95l.028-.07,2.919-7.123.018-.043.046.008,3.4.6.856.168C125.465,277.543,125.549,277.569,125.549,277.569Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5567",
    "data-name": "Group 5567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5560",
    "data-name": "Group 5560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5559",
    "data-name": "Group 5559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M177.018,285.855a7.8,7.8,0,0,1,1.451-1.491l-.353-1.9,2.931-1.263,1.137,1.559a7.826,7.826,0,0,1,2.081-.03l1.091-1.59,2.966,1.18-.3,1.9a7.867,7.867,0,0,1,1.492,1.451l1.9-.353,1.264,2.932-1.56,1.136a7.829,7.829,0,0,1,.03,2.081l1.59,1.091-1.179,2.967-1.906-.3a7.807,7.807,0,0,1-1.451,1.492l.353,1.9-2.932,1.263-1.136-1.559a7.828,7.828,0,0,1-2.081.029l-1.091,1.591-2.966-1.18.3-1.9a7.811,7.811,0,0,1-1.492-1.452l-1.9.354-1.263-2.932,1.56-1.137a7.779,7.779,0,0,1-.03-2.08l-1.591-1.092,1.18-2.966,1.906.3Zm3.187,3.289a3.425,3.425,0,1,0,4.448-1.917A3.425,3.425,0,0,0,180.205,289.144Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5563",
    "data-name": "Group 5563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5562",
    "data-name": "Group 5562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5561",
    "data-name": "Group 5561"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M180.205,289.144a2.584,2.584,0,0,1,.378-.76,3.463,3.463,0,0,1,3.476-1.414,3.508,3.508,0,0,1,1.661.814,3.52,3.52,0,0,1,1.071,1.74,3.493,3.493,0,0,1-1.538,3.867,3.509,3.509,0,0,1-1.973.529,3.5,3.5,0,0,1-1.767-.55,3.464,3.464,0,0,1-1.117-1.161,3.413,3.413,0,0,1-.438-2.254,2.59,2.59,0,0,1,.247-.811c.024.007-.106.286-.171.821a3.414,3.414,0,0,0,.481,2.172,3.345,3.345,0,0,0,2.77,1.6,3.338,3.338,0,0,0,1.866-.511,3.319,3.319,0,0,0,1.454-3.656,3.337,3.337,0,0,0-1-1.652,3.344,3.344,0,0,0-3.113-.739,3.414,3.414,0,0,0-1.842,1.248C180.325,288.863,180.227,289.154,180.205,289.144Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5566",
    "data-name": "Group 5566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5565",
    "data-name": "Group 5565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5564",
    "data-name": "Group 5564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M177.018,285.855a.649.649,0,0,1-.12-.011l-.362-.049-1.429-.208.034-.019-1.163,2.973-.018-.06,1.595,1.085.029.02,0,.035a7.806,7.806,0,0,0,.036,2.064l.006.038-.031.024-1.557,1.14.023-.084q.6,1.385,1.27,2.929l-.085-.045,1.9-.357.048-.009.031.038a7.767,7.767,0,0,0,1.478,1.434l.042.03-.008.051c-.092.591-.194,1.242-.3,1.906l-.054-.1,2.968,1.176-.109.033,1.089-1.591.032-.047.056.007a7.773,7.773,0,0,0,2.056-.031l.057-.009.034.047,1.137,1.558-.116-.031,2.932-1.264-.058.107c-.111-.6-.232-1.246-.353-1.9l-.011-.058.046-.037a7.709,7.709,0,0,0,1.432-1.472h0l.036-.048.059.009,1.9.3-.106.06,1.18-2.966.035.116-1.589-1.092-.049-.033.007-.058a7.677,7.677,0,0,0-.028-2.055l-.008-.057.046-.034,1.561-1.135-.031.113q-.645-1.5-1.26-2.933l.1.053-1.9.351-.053.009-.033-.041a7.731,7.731,0,0,0-1.473-1.438l-.041-.031.008-.05c.1-.654.2-1.287.3-1.9l.051.089-2.964-1.187.09-.027c-.385.559-.747,1.082-1.1,1.588l-.025.035-.042-.005a7.779,7.779,0,0,0-2.063.024l-.039.006-.023-.032L181,281.238l.069.019-2.937,1.25.026-.048.341,1.9,0,.019-.015.012a8.094,8.094,0,0,0-1.137,1.073l-.25.3a.682.682,0,0,1-.083.1,1.04,1.04,0,0,1,.07-.107c.051-.069.128-.173.238-.307a7.561,7.561,0,0,1,1.123-1.1l-.011.03-.366-1.894-.006-.035.032-.014,2.926-1.276.043-.018.027.037,1.142,1.556-.062-.026a7.944,7.944,0,0,1,2.1-.036l-.067.03c.347-.507.705-1.033,1.088-1.593l.034-.049.056.022,2.968,1.174.061.024-.01.064-.3,1.906-.034-.081a7.863,7.863,0,0,1,1.511,1.465l-.085-.032,1.9-.356.071-.013.029.066q.617,1.43,1.266,2.931l.029.068-.06.045-1.559,1.137.038-.091a7.931,7.931,0,0,1,.032,2.106l-.041-.09,1.59,1.09.064.044-.028.072q-.582,1.463-1.179,2.967l-.029.072-.078-.012-1.9-.3.094-.038h0a7.947,7.947,0,0,1-1.468,1.509l.035-.1c.121.651.242,1.3.353,1.9l.014.077-.071.031-2.933,1.261-.07.031-.045-.062-1.136-1.561.091.038a7.935,7.935,0,0,1-2.106.029l.088-.04c-.379.551-.752,1.1-1.093,1.59l-.041.06-.068-.027-2.965-1.184-.065-.026.011-.069c.1-.663.209-1.314.3-1.9l.034.081a7.944,7.944,0,0,1-1.506-1.469l.079.029-1.9.349-.061.012-.024-.057q-.661-1.545-1.256-2.934l-.022-.052.045-.033,1.563-1.132-.026.062a7.908,7.908,0,0,1-.024-2.1l.025.054-1.586-1.1-.033-.023.015-.037c.487-1.2.89-2.2,1.2-2.959l.009-.024.025,0,1.411.239.364.065A1.163,1.163,0,0,1,177.018,285.855Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5576",
    "data-name": "Group 5576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5569",
    "data-name": "Group 5569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5568",
    "data-name": "Group 5568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M162.732,244.468a13.094,13.094,0,0,1,2.426-2.493l-.591-3.171,4.9-2.111,1.9,2.607a13.05,13.05,0,0,1,3.478-.051l1.824-2.658,4.958,1.973-.5,3.184a13.066,13.066,0,0,1,2.493,2.426l3.171-.59,2.111,4.9-2.607,1.9a13.009,13.009,0,0,1,.05,3.478L189,255.685l-1.972,4.958-3.185-.5a13.071,13.071,0,0,1-2.426,2.494l.591,3.17-4.9,2.111-1.9-2.606a13.092,13.092,0,0,1-3.478.05l-1.824,2.658-4.958-1.972.5-3.185a13.061,13.061,0,0,1-2.493-2.425l-3.171.59-2.111-4.9,2.606-1.9a13.091,13.091,0,0,1-.05-3.478l-2.658-1.824,1.972-4.958,3.185.5Zm5.328,5.5a5.724,5.724,0,1,0,7.435-3.2A5.724,5.724,0,0,0,168.06,249.965Z",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5572",
    "data-name": "Group 5572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5571",
    "data-name": "Group 5571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5570",
    "data-name": "Group 5570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M168.06,249.965a4.324,4.324,0,0,1,.632-1.27,5.7,5.7,0,0,1,3.119-2.234,5.769,5.769,0,0,1,2.691-.129,5.853,5.853,0,0,1,2.776,1.361,5.848,5.848,0,0,1,1.79,2.907,5.841,5.841,0,0,1-2.571,6.464,5.86,5.86,0,0,1-3.3.884,5.871,5.871,0,0,1-2.953-.919,5.757,5.757,0,0,1-1.866-1.942,5.7,5.7,0,0,1-.733-3.766,4.319,4.319,0,0,1,.413-1.356c.039.012-.177.478-.287,1.373a5.711,5.711,0,0,0,.806,3.63,5.592,5.592,0,0,0,4.629,2.677,5.574,5.574,0,0,0,3.119-.854,5.543,5.543,0,0,0,2.43-6.11,5.6,5.6,0,0,0-1.68-2.762,5.593,5.593,0,0,0-5.2-1.235,5.71,5.71,0,0,0-3.079,2.086C168.26,249.495,168.1,249.982,168.06,249.965Z",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5575",
    "data-name": "Group 5575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5574",
    "data-name": "Group 5574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5573",
    "data-name": "Group 5573"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M162.732,244.468a1.1,1.1,0,0,1-.2-.019l-.6-.082-2.388-.347.057-.032-1.944,4.969-.03-.1,2.666,1.813.048.032-.007.059a13.031,13.031,0,0,0,.061,3.45l.01.064-.053.039-2.6,1.907.039-.141c.668,1.542,1.378,3.178,2.122,4.9l-.142-.076,3.17-.6.08-.015.051.065a13.029,13.029,0,0,0,2.471,2.4l.069.051-.013.085c-.154.987-.323,2.076-.5,3.185l-.09-.159,4.96,1.966-.182.056,1.821-2.66.054-.078.093.011a13.027,13.027,0,0,0,3.436-.052l.1-.015.057.078,1.9,2.606-.194-.053,4.9-2.113-.1.179c-.186-1-.388-2.082-.591-3.17l-.018-.1.078-.061a12.954,12.954,0,0,0,2.393-2.46l0,0,.06-.08.1.015,3.184.5-.177.1q1-2.513,1.973-4.958l.059.194-2.658-1.825-.08-.055.012-.1a12.9,12.9,0,0,0-.048-3.435l-.014-.1.078-.056q1.323-.963,2.608-1.9l-.051.188q-1.08-2.511-2.107-4.9l.167.088-3.172.586-.088.017-.054-.07a12.92,12.92,0,0,0-2.463-2.4l-.069-.051.014-.085c.173-1.092.341-2.15.505-3.184l.084.148-4.953-1.982.15-.046-1.831,2.654-.04.059-.071-.009a13.053,13.053,0,0,0-3.448.04l-.065.01-.038-.053-1.891-2.613.117.032-4.91,2.09.043-.081c.228,1.268.415,2.308.57,3.174l.006.032-.025.02a13.464,13.464,0,0,0-1.9,1.794c-.179.213-.317.375-.417.495a1.24,1.24,0,0,1-.14.162,1.9,1.9,0,0,1,.118-.179c.085-.116.213-.29.4-.513a12.593,12.593,0,0,1,1.877-1.842l-.019.051-.611-3.167-.011-.058.054-.023,4.891-2.133.071-.031.046.063,1.908,2.6-.1-.043a13.174,13.174,0,0,1,3.508-.06l-.111.05,1.817-2.663.057-.083.093.037,4.962,1.963.1.04-.017.108c-.161,1.034-.325,2.093-.495,3.185l-.056-.136a13.219,13.219,0,0,1,2.525,2.449l-.143-.054,3.17-.594.119-.022.048.111q1.032,2.39,2.116,4.9l.049.115-.1.073-2.6,1.9.064-.152a13.2,13.2,0,0,1,.052,3.52l-.068-.151,2.659,1.822.107.074-.048.12-1.971,4.959-.048.122-.13-.021-3.184-.5.157-.064,0,0a13.279,13.279,0,0,1-2.455,2.521l.06-.158c.2,1.088.4,2.169.59,3.17l.024.129-.12.051-4.9,2.109-.118.051-.076-.1-1.9-2.608.151.064a13.315,13.315,0,0,1-3.52.048l.147-.067-1.826,2.657-.069.1-.114-.045-4.955-1.978-.109-.044.018-.115c.176-1.108.349-2.2.5-3.183l.056.135a13.24,13.24,0,0,1-2.516-2.456l.131.05-3.172.584-.1.019-.041-.1c-.737-1.721-1.438-3.36-2.1-4.9l-.037-.086.076-.055,2.612-1.892-.043.1a13.154,13.154,0,0,1-.039-3.505l.041.091-2.651-1.835-.055-.038.025-.062,2-4.946.016-.039.041.007,2.358.4.609.109A1.612,1.612,0,0,1,162.732,244.468Z",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5578",
    "data-name": "Group 5578"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M342.824,320.918,384.17,314.6a41.826,41.826,0,1,1-36.754-35.255Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M356.239,279.478l-5.02,32.05,31.461-5.908S378.054,287.658,356.239,279.478Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5579",
    "data-name": "Group 5579"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M449.158,456.833c0,.144-92.2.26-205.9.26-113.745,0-205.923-.116-205.923-.26s92.178-.26,205.923-.26C356.96,456.573,449.158,456.689,449.158,456.833Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Graphics"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5614",
    "data-name": "Group 5614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5581",
    "data-name": "Group 5581"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_537",
    "data-name": "Rectangle 537",
    width: 179.051,
    height: 155.391,
    transform: "translate(282.516 97.216)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5580",
    "data-name": "Group 5580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M461.567,252.607s-.016-.982-.024-2.862-.014-4.67-.025-8.3c-.013-7.269-.033-17.926-.057-31.507-.027-27.14-.066-65.961-.113-112.718l.219.219-179.035.041h-.015l.26-.26c-.011,56.426-.021,109.583-.03,155.39l-.23-.23,129.513.116,36.536.061,9.664.027,2.487.013c.56,0,.85.013.85.013s-.273.009-.824.013l-2.462.013-9.619.028-36.484.06-129.661.116h-.231v-.231c-.009-45.807-.019-98.964-.03-155.39v-.261h.276L461.567,97h.22v.22c-.047,46.815-.086,85.684-.113,112.857-.025,13.56-.044,24.2-.057,31.458-.011,3.614-.019,6.385-.025,8.26S461.567,252.607,461.567,252.607Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5582",
    "data-name": "Group 5582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M445.06,139.041s-.245.016-.725.024l-2.135.023-8.249.043-30.685.077-104.242.089.255-.255c0,11.4,0,23.23.005,35.333,0,12.472,0,24.649-.005,36.407l-.255-.255,103.518.089,30.444.077,8.182.043,2.117.023c.476.007.719.023.719.023s-.243.016-.719.023l-2.117.023-8.182.044-30.444.076-103.518.089h-.255v-.255c0-11.758,0-23.935-.005-36.407,0-12.1,0-23.93.005-35.333v-.256h.255l104.242.089,30.685.077,8.249.043,2.135.023C444.815,139.026,445.06,139.041,445.06,139.041Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5583",
    "data-name": "Group 5583"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M445.06,151.119c0,.144-32.694.261-73.015.261s-73.021-.117-73.021-.261,32.687-.26,73.021-.26S445.06,150.975,445.06,151.119Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5584",
    "data-name": "Group 5584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M445.06,161c0,.144-32.694.26-73.015.26s-73.021-.116-73.021-.26,32.687-.26,73.021-.26S445.06,160.857,445.06,161Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5585",
    "data-name": "Group 5585"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M445.06,170.883c0,.144-32.694.26-73.015.26s-73.021-.116-73.021-.26,32.687-.261,73.021-.261S445.06,170.739,445.06,170.883Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5586",
    "data-name": "Group 5586"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M445.06,180.765c0,.143-32.694.26-73.015.26s-73.021-.117-73.021-.26,32.687-.261,73.021-.261S445.06,180.621,445.06,180.765Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5587",
    "data-name": "Group 5587"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M445.06,190.646c0,.144-32.694.261-73.015.261s-73.021-.117-73.021-.261,32.687-.26,73.021-.26S445.06,190.5,445.06,190.646Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5588",
    "data-name": "Group 5588"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M299.024,200.528c0-.144,32.694-.26,73.014-.26s73.022.116,73.022.26-32.687.261-73.022.261S299.024,200.672,299.024,200.528Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5589",
    "data-name": "Group 5589"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M327.942,211.874c-.143,0-.26-16.3-.26-36.415s.117-36.417.26-36.417.261,16.3.261,36.417S328.086,211.874,327.942,211.874Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5590",
    "data-name": "Group 5590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M357.222,211.874c-.144,0-.261-16.3-.261-36.415s.117-36.417.261-36.417.26,16.3.26,36.417S357.366,211.874,357.222,211.874Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5591",
    "data-name": "Group 5591"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M386.5,211.874c-.144,0-.26-16.3-.26-36.415s.116-36.417.26-36.417.26,16.3.26,36.417S386.645,211.874,386.5,211.874Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5592",
    "data-name": "Group 5592"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M415.78,211.874c-.143,0-.26-16.3-.26-36.415s.117-36.417.26-36.417.261,16.3.261,36.417S415.924,211.874,415.78,211.874Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5593",
    "data-name": "Group 5593"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M445.06,211.874c-.144,0-.261-16.3-.261-36.415s.117-36.417.261-36.417.26,16.3.26,36.417S445.2,211.874,445.06,211.874Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5594",
    "data-name": "Group 5594"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M445.06,151.119a7.7,7.7,0,0,1-1.1.858l-3.275,2.318-12.257,8.462c-10.437,7.154-25.041,17.089-41.638,28.316l-.211.142-.241-.081L373.9,186.943l-16.839-5.7.447-.06-29.339,19.674-.044.03-.047.016L306.9,208.229l-5.815,1.947-1.527.48a1.925,1.925,0,0,1-.534.126,1.918,1.918,0,0,1,.494-.239l1.488-.589,5.743-2.151,21.059-7.653-.09.045,29.219-19.852.208-.141.24.08,16.846,5.674,12.434,4.2-.452.061c16.619-11.194,31.295-21.023,41.833-28.027l12.432-8.2,3.375-2.171A7.72,7.72,0,0,1,445.06,151.119Z",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1231",
    "data-name": "Ellipse 1231",
    cx: 1.782,
    cy: 1.782,
    r: 1.782,
    transform: "translate(326.16 198.746)",
    fill: "#0f3576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M359,180.765a1.783,1.783,0,1,1-1.782-1.783A1.782,1.782,0,0,1,359,180.765Z",
    fill: "#0f3576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M388.283,190.477a1.782,1.782,0,1,1-1.782-1.783A1.782,1.782,0,0,1,388.283,190.477Z",
    fill: "#0f3576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M417.861,170.968a1.783,1.783,0,1,1-1.783-1.782A1.783,1.783,0,0,1,417.861,170.968Z",
    fill: "#0f3576"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5595",
    "data-name": "Group 5595"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M445.06,200.528a2.541,2.541,0,0,1-.555-.3l-1.559-.973-5.915-3.825-21.474-14.146H416l-29.224,19.66-.4.267-.286-.385-15.4-20.754L356.816,161.3l.765.054-29.366,29.56-.066.066-.086.028L306.3,198.077l-5.94,1.87-1.555.46a2.074,2.074,0,0,1-.541.121,2.076,2.076,0,0,1,.506-.228l1.52-.563,5.876-2.064,21.654-7.39-.151.094,29.192-29.731.413-.421.353.475c4.434,5.979,9.1,12.272,13.91,18.753L386.9,200.23l-.682-.119,29.335-19.494.226-.15.221.15,21.277,14.439,5.795,4,1.5,1.07A2.526,2.526,0,0,1,445.06,200.528Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M359,161a1.783,1.783,0,1,1-1.782-1.782A1.782,1.782,0,0,1,359,161Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M329.725,190.646a1.783,1.783,0,1,1-1.783-1.782A1.783,1.783,0,0,1,329.725,190.646Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M388.283,200.528a1.782,1.782,0,1,1-1.782-1.782A1.782,1.782,0,0,1,388.283,200.528Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1232",
    "data-name": "Ellipse 1232",
    cx: 1.782,
    cy: 1.782,
    r: 1.782,
    transform: "translate(413.998 180.764)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5596",
    "data-name": "Group 5596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M315.717,218.961a15.36,15.36,0,0,1-5.639,0,15.418,15.418,0,0,1,5.639,0Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5597",
    "data-name": "Group 5597"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M345.643,218.961a15.354,15.354,0,0,1-5.638,0,15.413,15.413,0,0,1,5.638,0Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5598",
    "data-name": "Group 5598"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M375.57,218.961a15.36,15.36,0,0,1-5.639,0,15.418,15.418,0,0,1,5.639,0Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5599",
    "data-name": "Group 5599"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M405.5,218.961a15.354,15.354,0,0,1-5.638,0,15.413,15.413,0,0,1,5.638,0Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5600",
    "data-name": "Group 5600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M435.423,218.961a15.36,15.36,0,0,1-5.639,0,15.418,15.418,0,0,1,5.639,0Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5608",
    "data-name": "Group 5608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5601",
    "data-name": "Group 5601"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M294.9,210.383a10.063,10.063,0,0,1-4.554,0,10.1,10.1,0,0,1,4.554,0Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5602",
    "data-name": "Group 5602"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M294.9,198.89a10.1,10.1,0,0,1-4.554,0,10.063,10.063,0,0,1,4.554,0Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5603",
    "data-name": "Group 5603"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M294.9,187.4a10.063,10.063,0,0,1-4.554,0,10.1,10.1,0,0,1,4.554,0Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5604",
    "data-name": "Group 5604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M294.9,175.9a10.1,10.1,0,0,1-4.554,0,10.063,10.063,0,0,1,4.554,0Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5605",
    "data-name": "Group 5605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M294.9,164.409a10.063,10.063,0,0,1-4.554,0,10.1,10.1,0,0,1,4.554,0Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5606",
    "data-name": "Group 5606"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M294.9,152.916a10.1,10.1,0,0,1-4.554,0,10.063,10.063,0,0,1,4.554,0Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5607",
    "data-name": "Group 5607"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M294.9,141.422a10.063,10.063,0,0,1-4.554,0,10.1,10.1,0,0,1,4.554,0Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_538",
    "data-name": "Rectangle 538",
    d: "M1.489,0H41.953a0,0,0,0,1,0,0V1.489a1.489,1.489,0,0,1-1.489,1.489H1.489A1.489,1.489,0,0,1,0,1.489v0A1.489,1.489,0,0,1,1.489,0Z",
    transform: "translate(298.265 114.187)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5609",
    "data-name": "Group 5609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M415.147,122.876c0,.144-26.232.26-58.583.26s-58.588-.116-58.588-.26,26.226-.261,58.588-.261S415.147,122.732,415.147,122.876Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5610",
    "data-name": "Group 5610"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M372.325,233.3c0,.144-15.994.261-35.719.261s-35.723-.117-35.723-.261,15.991-.26,35.723-.26S372.325,233.161,372.325,233.3Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5611",
    "data-name": "Group 5611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M318.029,238.7a55.985,55.985,0,0,1-7.62.26,56,56,0,0,1-7.621-.26,55.994,55.994,0,0,1,7.621-.26A55.984,55.984,0,0,1,318.029,238.7Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5612",
    "data-name": "Group 5612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M437.1,232.353c0,.143-11.374.26-25.4.26s-25.4-.117-25.4-.26,11.372-.261,25.4-.261S437.1,232.209,437.1,232.353Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5613",
    "data-name": "Group 5613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M409.475,235.845a120.842,120.842,0,0,1-15.876,0,121.309,121.309,0,0,1,15.876,0Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5619",
    "data-name": "Group 5619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5616",
    "data-name": "Group 5616"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_539",
    "data-name": "Rectangle 539",
    width: 97.44,
    height: 87.176,
    transform: "translate(85.654 130.049)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5615",
    "data-name": "Group 5615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M183.094,217.225s-.016-.559-.025-1.618-.014-2.634-.025-4.671c-.013-4.093-.033-10.075-.057-17.7-.028-15.231-.067-37-.114-63.19l.221.22-97.431.04h-.009l.26-.26c-.011,31.715-.022,61.559-.031,87.175L85.654,217l70.476.116,19.877.06,5.262.027,1.357.013c.306,0,.468.013.468.013s-.144.009-.442.013l-1.332.013-5.217.027-19.826.06-70.623.116h-.229v-.23c-.01-25.616-.02-55.46-.032-87.175v-.261h.27l97.431.04h.221v.221c-.047,26.252-.086,48.065-.114,63.33-.024,7.6-.044,13.565-.057,17.646-.011,2.019-.019,3.569-.025,4.629C183.11,216.7,183.094,217.225,183.094,217.225Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5617",
    "data-name": "Group 5617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M123.016,145.539c0,.144-5.129.26-11.454.26s-11.455-.116-11.455-.26,5.127-.26,11.455-.26S123.016,145.4,123.016,145.539Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5618",
    "data-name": "Group 5618"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M164.3,152.084c0,.144-14.09.261-31.467.261s-31.471-.117-31.471-.261,14.088-.26,31.471-.26S164.3,151.941,164.3,152.084Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_540",
    "data-name": "Rectangle 540",
    width: 4.105,
    height: 4.105,
    transform: "translate(100.275 163.172)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_541",
    "data-name": "Rectangle 541",
    width: 4.105,
    height: 4.105,
    transform: "translate(110.38 163.172)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_542",
    "data-name": "Rectangle 542",
    width: 4.105,
    height: 4.105,
    transform: "translate(120.671 162.986)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_543",
    "data-name": "Rectangle 543",
    width: 4.105,
    height: 4.105,
    transform: "translate(130.589 163.172)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_544",
    "data-name": "Rectangle 544",
    width: 4.105,
    height: 4.105,
    transform: "translate(140.694 163.172)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_545",
    "data-name": "Rectangle 545",
    width: 4.105,
    height: 4.105,
    transform: "translate(150.799 163.172)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_546",
    "data-name": "Rectangle 546",
    width: 4.105,
    height: 4.105,
    transform: "translate(160.904 163.172)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_547",
    "data-name": "Rectangle 547",
    width: 4.105,
    height: 4.105,
    transform: "translate(100.275 171.899)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_548",
    "data-name": "Rectangle 548",
    width: 4.105,
    height: 4.105,
    transform: "translate(110.38 171.899)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_549",
    "data-name": "Rectangle 549",
    width: 4.105,
    height: 4.105,
    transform: "translate(120.484 171.899)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_550",
    "data-name": "Rectangle 550",
    width: 4.105,
    height: 4.105,
    transform: "translate(130.589 171.899)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_551",
    "data-name": "Rectangle 551",
    width: 4.105,
    height: 4.105,
    transform: "translate(140.694 171.899)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_552",
    "data-name": "Rectangle 552",
    width: 4.105,
    height: 4.105,
    transform: "translate(150.986 171.713)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_553",
    "data-name": "Rectangle 553",
    width: 4.105,
    height: 4.105,
    transform: "translate(160.904 171.899)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_554",
    "data-name": "Rectangle 554",
    width: 4.105,
    height: 4.105,
    transform: "translate(100.275 180.626)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_555",
    "data-name": "Rectangle 555",
    width: 4.105,
    height: 4.105,
    transform: "translate(110.566 180.44)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_556",
    "data-name": "Rectangle 556",
    width: 4.105,
    height: 4.105,
    transform: "translate(120.484 180.626)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_557",
    "data-name": "Rectangle 557",
    width: 4.105,
    height: 4.105,
    transform: "translate(130.589 180.626)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_558",
    "data-name": "Rectangle 558",
    width: 4.105,
    height: 4.105,
    transform: "translate(140.694 180.626)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_559",
    "data-name": "Rectangle 559",
    width: 4.105,
    height: 4.105,
    transform: "translate(150.799 180.626)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_560",
    "data-name": "Rectangle 560",
    width: 4.105,
    height: 4.105,
    transform: "translate(160.904 180.626)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_561",
    "data-name": "Rectangle 561",
    width: 4.105,
    height: 4.105,
    transform: "translate(100.275 189.354)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_562",
    "data-name": "Rectangle 562",
    width: 4.105,
    height: 4.105,
    transform: "translate(110.38 189.354)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_563",
    "data-name": "Rectangle 563",
    width: 4.105,
    height: 4.105,
    transform: "translate(120.484 189.354)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    width: 4.105,
    height: 4.105,
    transform: "translate(130.776 189.167)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_565",
    "data-name": "Rectangle 565",
    width: 4.105,
    height: 4.105,
    transform: "translate(140.694 189.354)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_566",
    "data-name": "Rectangle 566",
    width: 4.105,
    height: 4.105,
    transform: "translate(150.799 189.354)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_567",
    "data-name": "Rectangle 567",
    width: 4.105,
    height: 4.105,
    transform: "translate(160.904 189.354)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_568",
    "data-name": "Rectangle 568",
    width: 4.105,
    height: 4.105,
    transform: "translate(100.275 198.081)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_569",
    "data-name": "Rectangle 569",
    width: 4.105,
    height: 4.105,
    transform: "translate(110.38 198.081)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_570",
    "data-name": "Rectangle 570",
    width: 4.105,
    height: 4.105,
    transform: "translate(120.484 198.081)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_571",
    "data-name": "Rectangle 571",
    width: 4.105,
    height: 4.105,
    transform: "translate(130.589 198.081)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_572",
    "data-name": "Rectangle 572",
    width: 4.105,
    height: 4.105,
    transform: "translate(140.694 198.081)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_573",
    "data-name": "Rectangle 573",
    width: 4.105,
    height: 4.105,
    transform: "translate(150.986 197.895)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_574",
    "data-name": "Rectangle 574",
    width: 4.105,
    height: 4.105,
    transform: "translate(160.904 198.081)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5624",
    "data-name": "Group 5624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5620",
    "data-name": "Group 5620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M177.944,95.212a2.246,2.246,0,0,1-.027-.373c-.007-.279-.016-.618-.028-1.032-.015-.949-.036-2.237-.061-3.84-.029-3.32-.07-7.937-.117-13.4l.233.233-14.789.027c-.059.056.492-.491.259-.257v2.561q0,1.271,0,2.513,0,2.484-.009,4.84c-.012,3.128-.023,6.062-.033,8.732L163.153,95l10.674.112,3.017.055a10.713,10.713,0,0,1,1.1.049,7.937,7.937,0,0,1-1.012.048l-2.969.056-10.81.112-.215,0v-.218c-.01-2.67-.021-5.6-.032-8.732q0-2.352-.009-4.84,0-1.242,0-2.513V76.566c-.233.231.316-.321.262-.264l14.789.027h.235l0,.233c-.047,5.528-.087,10.2-.116,13.555-.026,1.582-.047,2.852-.062,3.787-.011.4-.02.72-.028.986A1.3,1.3,0,0,1,177.944,95.212Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5621",
    "data-name": "Group 5621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M197.558,95.212a1.6,1.6,0,0,1-.016-.243c0-.18-.01-.4-.016-.682q-.012-.942-.033-2.607c-.017-2.292-.041-5.566-.072-9.649-.029-8.207-.07-19.659-.116-32.8l.253.254-13.823.007c.514-.522.142-.137.257-.25v3.451q0,1.719,0,3.412,0,3.384-.005,6.644c-.007,4.341-.013,8.5-.019,12.413-.027,7.812-.051,14.652-.07,20.05l-.165-.166,10.133.091,2.728.041.712.017a1.6,1.6,0,0,1,.253.017,1.051,1.051,0,0,1-.22.017l-.683.017-2.692.04-10.231.091-.165,0v-.167c-.018-5.4-.042-12.238-.069-20.05-.006-3.914-.012-8.072-.019-12.413q0-3.257,0-6.644,0-1.692,0-3.412V49.242c.117-.119-.263.248.263-.271l13.823.007h.254v.253c-.046,13.211-.087,24.724-.116,32.975-.03,4.059-.055,7.313-.072,9.591q-.021,1.629-.033,2.553c-.006.265-.011.48-.016.651A.874.874,0,0,1,197.558,95.212Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5622",
    "data-name": "Group 5622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M217.685,95.212a4.393,4.393,0,0,1-.03-.559c-.007-.4-.017-.915-.03-1.562-.016-1.4-.039-3.355-.067-5.794-.03-4.962-.071-11.884-.118-19.953l.245.245-13.949.015c-.061.055.492-.489.258-.254v3.978q0,1.966,0,3.878c0,2.545-.009,5.007-.013,7.363-.018,4.7-.035,8.976-.049,12.643l-.193-.194,10.143.1,2.8.048.741.021a1.482,1.482,0,0,1,.266.021,7.9,7.9,0,0,1-.932.041L214,95.3l-10.262.1-.193,0v-.195c-.014-3.667-.031-7.942-.049-12.643,0-2.356-.009-4.818-.013-7.363q0-1.91,0-3.878V67.35c-.232.231.315-.325.263-.267l13.949.015h.247v.245c-.048,8.135-.089,15.114-.118,20.117-.029,2.416-.051,4.353-.068,5.738-.012.626-.022,1.126-.03,1.512A2.939,2.939,0,0,1,217.685,95.212Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5623",
    "data-name": "Group 5623"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M238.214,95.212A1.194,1.194,0,0,1,238.2,95c0-.159-.009-.352-.016-.588-.007-.549-.018-1.3-.032-2.246-.016-1.983-.04-4.8-.07-8.326-.029-7.1-.07-17.009-.117-28.457l.251.251-14.547.01c.515-.522.143-.138.258-.252v2.931q0,1.462,0,2.9,0,2.88,0,5.663c-.006,3.707-.011,7.272-.017,10.652-.023,6.746-.044,12.749-.061,17.67l-.177-.177,10.626.1,2.894.044.759.019a1.755,1.755,0,0,1,.271.018,1.048,1.048,0,0,1-.235.018l-.728.019-2.854.043-10.733.1-.176,0v-.178c-.017-4.921-.038-10.924-.061-17.67-.006-3.38-.011-6.945-.017-10.652q0-2.781-.005-5.663,0-1.44,0-2.9V55.394c.117-.119-.263.25.263-.269l14.547.009h.252v.25c-.047,11.517-.088,21.49-.118,28.629-.029,3.5-.053,6.3-.07,8.268q-.019,1.391-.032,2.193A6.306,6.306,0,0,1,238.214,95.212Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5859",
    "data-name": "Group 5859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5693",
    "data-name": "Group 5693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M244.021,365.44c1.558,3.655,8.079,88.79,7.387,87.5l16.447-1.084,1.076-88.4Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5692",
    "data-name": "Group 5692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5691",
    "data-name": "Group 5691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5631",
    "data-name": "Group 5631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5627",
    "data-name": "Group 5627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5626",
    "data-name": "Group 5626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5625",
    "data-name": "Group 5625"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M268.353,452.7l-.051-1.525-17.529.322.106,5.026,1.083.039c4.821.139,24.524.43,27.722-.422C283.251,455.183,268.353,452.7,268.353,452.7Z",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5630",
    "data-name": "Group 5630",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5629",
    "data-name": "Group 5629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5628",
    "data-name": "Group 5628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M257.2,456.3a4.963,4.963,0,0,0-2.306-3.01,6.85,6.85,0,0,0-4.106-.971l.1,3.994Z",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5634",
    "data-name": "Group 5634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5633",
    "data-name": "Group 5633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5632",
    "data-name": "Group 5632",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M275.638,454.122s5.229,1.142,4.6,1.854-20.554,1.031-29.358.542l.02-.32,23.243-.21S274.623,454.174,275.638,454.122Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5638",
    "data-name": "Group 5638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5637",
    "data-name": "Group 5637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5636",
    "data-name": "Group 5636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5635",
    "data-name": "Group 5635"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M250.624,456.194a2.034,2.034,0,0,0,.3.022l.863.029,3.174.06c2.681.036,6.385.046,10.476-.017s7.793-.187,10.47-.306l3.168-.159.861-.055a.151.151,0,1,0,0-.035l-.863.023-3.171.1c-2.678.087-6.379.191-10.468.255s-7.79.073-10.47.068l-3.174-.006-.863,0A2.009,2.009,0,0,0,250.624,456.194Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5642",
    "data-name": "Group 5642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5641",
    "data-name": "Group 5641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5640",
    "data-name": "Group 5640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5639",
    "data-name": "Group 5639"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M274.143,456.21a5.213,5.213,0,0,1,.561-1.25,6.407,6.407,0,0,1,1.056-1.011,2.294,2.294,0,0,0-1.239.924A1.636,1.636,0,0,0,274.143,456.21Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5646",
    "data-name": "Group 5646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5645",
    "data-name": "Group 5645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5644",
    "data-name": "Group 5644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5643",
    "data-name": "Group 5643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M268.94,454.153c.05.025.29-.225.536-.557s.406-.622.356-.647-.29.224-.537.557S268.89,454.128,268.94,454.153Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5650",
    "data-name": "Group 5650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5649",
    "data-name": "Group 5649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5648",
    "data-name": "Group 5648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5647",
    "data-name": "Group 5647"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M267.512,453.564c.04.035.311-.12.606-.346s.5-.438.462-.473-.312.12-.607.346S267.472,453.529,267.512,453.564Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5654",
    "data-name": "Group 5654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5653",
    "data-name": "Group 5653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5652",
    "data-name": "Group 5652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5651",
    "data-name": "Group 5651"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M266.584,452.229a4.824,4.824,0,0,0,1.824-.012,4.878,4.878,0,0,0-1.824.012Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5658",
    "data-name": "Group 5658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5657",
    "data-name": "Group 5657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5656",
    "data-name": "Group 5656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5655",
    "data-name": "Group 5655"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M266.253,451.283a2.059,2.059,0,0,0,1.022.226,2.124,2.124,0,0,0,1.047-.131,6.646,6.646,0,0,0-1.035-.042A6.854,6.854,0,0,0,266.253,451.283Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5662",
    "data-name": "Group 5662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5661",
    "data-name": "Group 5661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5660",
    "data-name": "Group 5660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5659",
    "data-name": "Group 5659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M269.5,452.9a3.987,3.987,0,0,0,1.122-.024,7.687,7.687,0,0,0,1.188-.235,3.636,3.636,0,0,0,.677-.241.526.526,0,0,0,.271-.29.334.334,0,0,0-.18-.364,2.333,2.333,0,0,0-2.53.533,1.514,1.514,0,0,0-.35.619c-.041.158-.036.247-.023.248a2.445,2.445,0,0,1,.491-.791,2.064,2.064,0,0,1,.945-.525,2.087,2.087,0,0,1,1.338.053c.181.1.116.277-.08.377a3.707,3.707,0,0,1-.624.231,9.348,9.348,0,0,1-1.149.265C269.927,452.861,269.5,452.869,269.5,452.9Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5666",
    "data-name": "Group 5666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5665",
    "data-name": "Group 5665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5664",
    "data-name": "Group 5664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5663",
    "data-name": "Group 5663"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M269.792,452.938a.774.774,0,0,0,.113-.64,1.36,1.36,0,0,0-.323-.666,1.187,1.187,0,0,0-.946-.453.368.368,0,0,0-.334.43.907.907,0,0,0,.2.407,2.96,2.96,0,0,0,.543.547,1.685,1.685,0,0,0,.651.361c.02-.023-.227-.161-.544-.447a3.293,3.293,0,0,1-.483-.543c-.159-.192-.273-.539.007-.585a1.058,1.058,0,0,1,.748.378,1.4,1.4,0,0,1,.333.592A2.8,2.8,0,0,1,269.792,452.938Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5670",
    "data-name": "Group 5670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5669",
    "data-name": "Group 5669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5668",
    "data-name": "Group 5668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5667",
    "data-name": "Group 5667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M250.881,452.278c.005.032.5-.047,1.29.017a6.421,6.421,0,0,1,2.837.9,4.79,4.79,0,0,1,1.809,2.006c.282.608.318,1.019.357,1.015a.676.676,0,0,0-.006-.289,3.224,3.224,0,0,0-.21-.767,4.533,4.533,0,0,0-1.822-2.1,6.191,6.191,0,0,0-2.954-.888,5.51,5.51,0,0,0-.959.035A1.216,1.216,0,0,0,250.881,452.278Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5674",
    "data-name": "Group 5674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5673",
    "data-name": "Group 5673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5672",
    "data-name": "Group 5672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5671",
    "data-name": "Group 5671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M259.363,454.873a17.485,17.485,0,0,0,5.1-.042c-.007-.051-1.145.025-2.55.035S259.369,454.823,259.363,454.873Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5678",
    "data-name": "Group 5678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5677",
    "data-name": "Group 5677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5676",
    "data-name": "Group 5676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5675",
    "data-name": "Group 5675"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M255.943,454.923c-.041.036.1.2.22.409s.191.4.251.4.084-.227-.06-.472S255.98,454.888,255.943,454.923Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5682",
    "data-name": "Group 5682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5681",
    "data-name": "Group 5681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5680",
    "data-name": "Group 5680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5679",
    "data-name": "Group 5679"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M254.621,453.63c-.041.035.076.182.26.329s.367.238.408.2-.076-.181-.26-.329S254.662,453.6,254.621,453.63Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5686",
    "data-name": "Group 5686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5685",
    "data-name": "Group 5685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5684",
    "data-name": "Group 5684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5683",
    "data-name": "Group 5683"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M252.761,453.06c.014.048.246.043.5.113s.446.178.491.145-.106-.228-.427-.311S252.743,453.016,252.761,453.06Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5690",
    "data-name": "Group 5690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5689",
    "data-name": "Group 5689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5688",
    "data-name": "Group 5688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5687",
    "data-name": "Group 5687"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M251.441,452.8c-.02.045.083.117.228.16s.281.043.3,0-.082-.117-.228-.161S251.461,452.753,251.441,452.8Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5762",
    "data-name": "Group 5762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M212.242,365.853c.461,1.608,9.079,87.7,9.079,87.7l16.447-1.084,1.076-86.614Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5761",
    "data-name": "Group 5761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5760",
    "data-name": "Group 5760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5700",
    "data-name": "Group 5700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5696",
    "data-name": "Group 5696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5695",
    "data-name": "Group 5695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5694",
    "data-name": "Group 5694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M238.266,453.308l-.052-1.525-17.528.322.106,5.026,1.083.039c4.821.14,24.524.43,27.722-.422C253.164,455.8,238.266,453.308,238.266,453.308Z",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5699",
    "data-name": "Group 5699",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5698",
    "data-name": "Group 5698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5697",
    "data-name": "Group 5697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M227.115,456.915a4.96,4.96,0,0,0-2.306-3.011,6.848,6.848,0,0,0-4.106-.971l.1,3.994Z",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5703",
    "data-name": "Group 5703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5702",
    "data-name": "Group 5702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5701",
    "data-name": "Group 5701",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M245.551,454.736s5.228,1.141,4.6,1.853-20.553,1.031-29.357.542l.019-.319,23.244-.211S244.536,454.787,245.551,454.736Z",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5707",
    "data-name": "Group 5707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5706",
    "data-name": "Group 5706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5705",
    "data-name": "Group 5705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5704",
    "data-name": "Group 5704"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M220.537,456.807a2.02,2.02,0,0,0,.3.022l.862.029,3.175.061c2.68.036,6.385.045,10.475-.018s7.793-.187,10.47-.306l3.169-.158.861-.056a1.878,1.878,0,0,0,.3-.031,1.992,1.992,0,0,0-.3,0l-.862.023-3.172.1c-2.678.087-6.378.191-10.467.255s-7.79.073-10.47.068l-3.174-.006-.864,0A2,2,0,0,0,220.537,456.807Z",
    fill: "#263238",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5711",
    "data-name": "Group 5711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5710",
    "data-name": "Group 5710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5709",
    "data-name": "Group 5709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5708",
    "data-name": "Group 5708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M244.056,456.823a5.168,5.168,0,0,1,.561-1.249,6.344,6.344,0,0,1,1.056-1.012,2.294,2.294,0,0,0-1.239.924A1.636,1.636,0,0,0,244.056,456.823Z",
    fill: "#263238",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5715",
    "data-name": "Group 5715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5714",
    "data-name": "Group 5714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5713",
    "data-name": "Group 5713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5712",
    "data-name": "Group 5712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M238.853,454.766c.05.025.29-.224.536-.557s.4-.622.355-.647-.29.225-.536.557S238.8,454.742,238.853,454.766Z",
    fill: "#263238",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5719",
    "data-name": "Group 5719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5718",
    "data-name": "Group 5718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5717",
    "data-name": "Group 5717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5716",
    "data-name": "Group 5716"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M237.424,454.177c.04.035.312-.12.607-.346s.5-.437.462-.472-.312.12-.607.346S237.384,454.142,237.424,454.177Z",
    fill: "#263238",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5723",
    "data-name": "Group 5723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5722",
    "data-name": "Group 5722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5721",
    "data-name": "Group 5721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5720",
    "data-name": "Group 5720"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M236.5,452.843a4.845,4.845,0,0,0,1.823-.013,2.486,2.486,0,0,0-.912-.08A2.452,2.452,0,0,0,236.5,452.843Z",
    fill: "#263238",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5727",
    "data-name": "Group 5727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5726",
    "data-name": "Group 5726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5725",
    "data-name": "Group 5725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5724",
    "data-name": "Group 5724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M236.166,451.9a2.065,2.065,0,0,0,1.022.225,2.115,2.115,0,0,0,1.046-.131,6.936,6.936,0,0,0-1.034-.042A6.77,6.77,0,0,0,236.166,451.9Z",
    fill: "#263238",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5731",
    "data-name": "Group 5731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5730",
    "data-name": "Group 5730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5729",
    "data-name": "Group 5729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5728",
    "data-name": "Group 5728"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M239.413,453.51a3.887,3.887,0,0,0,1.121-.024,7.79,7.79,0,0,0,1.189-.234,3.72,3.72,0,0,0,.677-.242.521.521,0,0,0,.27-.29.335.335,0,0,0-.179-.364,2.335,2.335,0,0,0-2.53.534,1.517,1.517,0,0,0-.351.618c-.041.158-.035.247-.022.249a2.393,2.393,0,0,1,.49-.792,2.243,2.243,0,0,1,2.284-.472c.18.1.116.278-.08.378a3.773,3.773,0,0,1-.625.23,8.947,8.947,0,0,1-1.148.265C239.84,453.474,239.412,453.482,239.413,453.51Z",
    fill: "#263238",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5735",
    "data-name": "Group 5735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5734",
    "data-name": "Group 5734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5733",
    "data-name": "Group 5733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5732",
    "data-name": "Group 5732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M239.705,453.551a.775.775,0,0,0,.113-.639,1.376,1.376,0,0,0-.323-.667,1.188,1.188,0,0,0-.946-.453.37.37,0,0,0-.335.43.928.928,0,0,0,.2.407,2.963,2.963,0,0,0,.544.547,1.714,1.714,0,0,0,.651.362c.019-.023-.227-.162-.544-.447a3.4,3.4,0,0,1-.484-.544c-.158-.192-.273-.538.008-.585a1.058,1.058,0,0,1,.748.378,1.4,1.4,0,0,1,.332.592A2.766,2.766,0,0,1,239.705,453.551Z",
    fill: "#263238",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5739",
    "data-name": "Group 5739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5738",
    "data-name": "Group 5738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5737",
    "data-name": "Group 5737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5736",
    "data-name": "Group 5736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M220.794,452.891c0,.033.5-.046,1.289.017a6.443,6.443,0,0,1,2.837.9,4.794,4.794,0,0,1,1.81,2.006c.282.608.318,1.02.357,1.015a.665.665,0,0,0-.007-.288,3.206,3.206,0,0,0-.209-.768,4.532,4.532,0,0,0-1.822-2.1,6.183,6.183,0,0,0-2.954-.889,5.628,5.628,0,0,0-.96.035A1.216,1.216,0,0,0,220.794,452.891Z",
    fill: "#263238",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5743",
    "data-name": "Group 5743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5742",
    "data-name": "Group 5742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5741",
    "data-name": "Group 5741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5740",
    "data-name": "Group 5740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M229.276,455.486a17.478,17.478,0,0,0,5.1-.042c-.007-.05-1.144.025-2.55.035S229.282,455.436,229.276,455.486Z",
    fill: "#263238",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5747",
    "data-name": "Group 5747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5746",
    "data-name": "Group 5746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5745",
    "data-name": "Group 5745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5744",
    "data-name": "Group 5744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M225.856,455.537c-.042.035.1.2.22.408s.19.4.25.4.084-.227-.059-.471S225.893,455.5,225.856,455.537Z",
    fill: "#263238",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5751",
    "data-name": "Group 5751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5750",
    "data-name": "Group 5750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5749",
    "data-name": "Group 5749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5748",
    "data-name": "Group 5748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M224.534,454.244c-.041.034.075.181.26.328s.366.238.407.2-.075-.181-.26-.328S224.574,454.21,224.534,454.244Z",
    fill: "#263238",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5755",
    "data-name": "Group 5755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5754",
    "data-name": "Group 5754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5753",
    "data-name": "Group 5753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5752",
    "data-name": "Group 5752"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M222.674,453.673c.014.048.246.043.5.113s.445.179.49.145-.1-.228-.427-.31S222.655,453.629,222.674,453.673Z",
    fill: "#263238",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5759",
    "data-name": "Group 5759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5758",
    "data-name": "Group 5758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5757",
    "data-name": "Group 5757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5756",
    "data-name": "Group 5756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M221.354,453.411c-.02.045.082.117.228.16s.281.043.3,0-.082-.117-.228-.16S221.374,453.366,221.354,453.411Z",
    fill: "#263238",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5792",
    "data-name": "Group 5792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5771",
    "data-name": "Group 5771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5764",
    "data-name": "Group 5764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5763",
    "data-name": "Group 5763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M310.685,213.676h0c3.314-2.146,5.384-3.928,7.631-5.215,2.769-1.587,3.8-2.436,3.469-2.935-.441-.667-.241-.43-5.685,1.738,0,0,7.744-3.163,5.528-3.8-.981-.28-7.442,2.285-7.442,2.285,5.379-1.584,7.155-3.031,6.873-3.832-.41-1.16-8.229,2.013-8.229,2.013s6.012-2.3,6.938-3.033-.468-1.031-1.692-.952c-1.374.089-9.28,1.749-11.587,2.109a1.377,1.377,0,0,1-1.736-1.168c.106-3.387-1.62-6.081-2.431-6.591s-1.782.433-1.378,1.411a12.693,12.693,0,0,1,.537,3.389,8.117,8.117,0,0,1-.3,2.72c-.3,1.023-.587,1.878-.853,2.6l-15.312,23.946,6.639,16.407Z",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5766",
    "data-name": "Group 5766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5765",
    "data-name": "Group 5765"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M312.852,208.645a30.258,30.258,0,0,0,7.376-3.153,30.361,30.361,0,0,0-7.376,3.153Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5768",
    "data-name": "Group 5768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5767",
    "data-name": "Group 5767"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M311.8,206.642a34.443,34.443,0,0,0,8.062-2.885,34.564,34.564,0,0,0-8.062,2.885Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5770",
    "data-name": "Group 5770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5769",
    "data-name": "Group 5769"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M310.717,204.556a30.949,30.949,0,0,0,7.664-2.628,30.913,30.913,0,0,0-7.664,2.628Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M267.528,188.675v36.6l.192,26.316L226.9,265.025l.4-20.035s-8.439-26.394-8.435-26.83-.8-28.751-.8-28.751l15.1-3.666,18.951-.228Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M218.058,189.409s-5.323,2.353-7.482,4.1c-1.44,1.166-13.966,23.65-22.143,38.485a14,14,0,0,0,6.12,19.336l23.442,11.446,7.086-19.655-13.425-7.255,10.144-17.65-3.742-28.809",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M218,262.778l-8.725-.645v-7.319l12.759-3.228Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M209.343,235.546a19.2,19.2,0,0,0,4.3.086,6.44,6.44,0,0,0,3.841-1.764c1.378-1.437,1.721-3.547,2-5.518q.719-5.094,1.436-10.19c-3.441.212-6.341,2.886-7.825,6s-1.816,6.629-2.127,10.063",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M267.528,188.675,284,226.093l10.583-14.521s10.782,5.293,9.488,20.682l-12.815,17.411a11.877,11.877,0,0,1-17.687-3.414l-11.524-20.158Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M225.976,187.486c-.164.059,23.736,26.6,23.736,26.6l4.926-28.053S239.839,182.517,225.976,187.486Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5772",
    "data-name": "Group 5772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M267.721,233.434a2.9,2.9,0,0,1-.479-.416l-1.3-1.263c-1.123-1.1-2.717-2.726-4.666-4.754-3.9-4.054-9.165-9.772-14.879-16.173L231.816,194.39l-4.418-4.981-1.188-1.366a2.936,2.936,0,0,1-.389-.5,2.939,2.939,0,0,1,.466.429l1.26,1.3c1.089,1.135,2.64,2.8,4.542,4.872,3.807,4.14,8.984,9.934,14.7,16.337s10.928,12.152,14.758,16.267l4.544,4.866,1.228,1.331A2.944,2.944,0,0,1,267.721,233.434Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5773",
    "data-name": "Group 5773"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M226.132,241.347a6.64,6.64,0,0,1-.43-1.261l-1.02-3.477c-.86-2.935-2.109-6.969-3.5-11.429s-2.555-8.532-3.283-11.508c-.366-1.488-.641-2.7-.8-3.539a6.557,6.557,0,0,1-.208-1.316,6.525,6.525,0,0,1,.4,1.269c.255.924.578,2.094.963,3.492.817,2.946,2.039,6.988,3.425,11.448s2.581,8.52,3.352,11.485c.384,1.482.68,2.686.861,3.524A6.507,6.507,0,0,1,226.132,241.347Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5774",
    "data-name": "Group 5774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M200.687,233.682c-.025,0-.1-.191-.043-.556a2.093,2.093,0,0,1,.844-1.275,3.062,3.062,0,0,1,2.19-.6,6.7,6.7,0,0,1,2.564.949c3.211,1.965,6.048,3.058,6,3.2a20.048,20.048,0,0,1-6.256-2.747,6.8,6.8,0,0,0-2.365-.927,2.8,2.8,0,0,0-1.921.422,2.089,2.089,0,0,0-.86,1.027C200.731,233.485,200.732,233.681,200.687,233.682Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5775",
    "data-name": "Group 5775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M219.985,240.661c.061.065-.918,1.009-2.317,2.687a37.541,37.541,0,0,0-7.64,15.074c-.527,2.121-.709,3.468-.8,3.457a3.415,3.415,0,0,1,.035-.959,23.3,23.3,0,0,1,.4-2.58,32.931,32.931,0,0,1,7.721-15.233,23.312,23.312,0,0,1,1.842-1.851A3.384,3.384,0,0,1,219.985,240.661Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5776",
    "data-name": "Group 5776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M266.165,197.995a8.212,8.212,0,0,1,.445,1.441c.253.937.6,2.295.994,3.986a61.893,61.893,0,0,1,1.794,13.443,70.039,70.039,0,0,1-1.5,13.483c-.335,1.7-.635,3.072-.854,4.017a8.342,8.342,0,0,1-.394,1.456,8.525,8.525,0,0,1,.195-1.5c.179-1.048.411-2.408.691-4.043a80.279,80.279,0,0,0,1.338-13.414,69.607,69.607,0,0,0-1.633-13.368c-.336-1.624-.615-2.975-.831-4.017A8.455,8.455,0,0,1,266.165,197.995Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5777",
    "data-name": "Group 5777"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M283.651,238.054a28.666,28.666,0,0,1,.1-5.454,28.792,28.792,0,0,1,.622-5.42,28.774,28.774,0,0,1-.1,5.455A28.788,28.788,0,0,1,283.651,238.054Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5778",
    "data-name": "Group 5778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M288.4,237.6a42.577,42.577,0,0,1-2.677-6.069,42.4,42.4,0,0,1-2.193-6.261,42.36,42.36,0,0,1,2.677,6.07A42.328,42.328,0,0,1,288.4,237.6Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5779",
    "data-name": "Group 5779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M297.005,241.858c-.1-.01.064-1.368,0-3.553a22.7,22.7,0,0,0-1.831-8.257,26.464,26.464,0,0,0-4.727-7.043c-1.488-1.607-2.517-2.5-2.457-2.573a3.381,3.381,0,0,1,.782.56,25,25,0,0,1,6.879,8.847,20.946,20.946,0,0,1,1.722,8.46,19.573,19.573,0,0,1-.18,2.616A3.455,3.455,0,0,1,297.005,241.858Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5780",
    "data-name": "Group 5780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M233.483,196.892c-.028.042-.392-.206-1.112-.51a7.9,7.9,0,0,0-3.217-.558,7.418,7.418,0,0,0-4.456,1.624c-1.429,1.14-2.375,3-3.795,4.687a6.762,6.762,0,0,1-2.586,1.959,6.193,6.193,0,0,1-3.006.358,9.333,9.333,0,0,1-4.615-1.991,20.782,20.782,0,0,1-2.478-2.288,5.412,5.412,0,0,1-.8-.943,5.908,5.908,0,0,1,.939.8,27.4,27.4,0,0,0,2.554,2.135,9.224,9.224,0,0,0,4.447,1.811,5.8,5.8,0,0,0,2.765-.354,6.365,6.365,0,0,0,2.382-1.826c1.364-1.6,2.342-3.51,3.887-4.72a7.639,7.639,0,0,1,4.752-1.619,7.467,7.467,0,0,1,3.306.741,5.561,5.561,0,0,1,.787.483C233.41,196.8,233.493,196.878,233.483,196.892Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5781",
    "data-name": "Group 5781"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M218.772,230.581c.006.017-.088.058-.274.122a3.111,3.111,0,0,1-.848.153,4.967,4.967,0,0,1-3.01-.921,8.433,8.433,0,0,1-2.973-3.6c-.761-1.6-1.237-3.47-1.973-5.306a11.767,11.767,0,0,0-3.115-4.515,12.519,12.519,0,0,0-3.86-2.336,17.213,17.213,0,0,0-4.111-.864,3.7,3.7,0,0,1,1.148-.064,10.473,10.473,0,0,1,3.088.582,12.293,12.293,0,0,1,4.052,2.321,11.923,11.923,0,0,1,3.281,4.68c.754,1.888,1.212,3.745,1.926,5.3a8.3,8.3,0,0,0,2.745,3.5,5.037,5.037,0,0,0,2.8,1.022C218.365,230.665,218.759,230.529,218.772,230.581Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5782",
    "data-name": "Group 5782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M194.4,251.456a5.048,5.048,0,0,0,1.017-.21,4.058,4.058,0,0,0,1.942-1.946,15.641,15.641,0,0,0,1.215-4.058,20.67,20.67,0,0,1,1.5-5.113,7.363,7.363,0,0,1,1.712-2.233,7.909,7.909,0,0,1,2.24-1.353,10.817,10.817,0,0,1,4.307-.721,17.338,17.338,0,0,1,2.909.332,3.829,3.829,0,0,1,1.035.278c-.013.1-1.515-.238-3.945-.242a11,11,0,0,0-4.123.8,7.024,7.024,0,0,0-3.671,3.38,21.617,21.617,0,0,0-1.5,4.978,14.8,14.8,0,0,1-1.364,4.137,4.07,4.07,0,0,1-2.2,1.957,2.119,2.119,0,0,1-.809.086C194.495,251.5,194.4,251.473,194.4,251.456Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5783",
    "data-name": "Group 5783"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M222.147,251.649a32.8,32.8,0,0,0-5.885.811,32.8,32.8,0,0,0-5.453,2.356,13.752,13.752,0,0,1,11.338-3.167Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5784",
    "data-name": "Group 5784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M248.1,213.1a8.014,8.014,0,0,1-1.173.477A13.923,13.923,0,0,0,244,215.337a49.821,49.821,0,0,0-3.8,3.418,21.293,21.293,0,0,1-5.045,3.832,10.277,10.277,0,0,1-6.268.914,18.943,18.943,0,0,1-4.931-1.575,34.277,34.277,0,0,1-3.073-1.62,5.762,5.762,0,0,1-1.065-.7c.045-.086,1.62.823,4.287,1.983a19.878,19.878,0,0,0,4.852,1.438,9.989,9.989,0,0,0,5.968-.908,21.835,21.835,0,0,0,4.948-3.715,42.937,42.937,0,0,1,3.9-3.363,12.233,12.233,0,0,1,3.07-1.657A4.755,4.755,0,0,1,248.1,213.1Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5785",
    "data-name": "Group 5785"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M269.51,217.107c0,.162-3.636.038-8.04.7-4.409.638-7.85,1.807-7.9,1.652a8.943,8.943,0,0,1,2.215-.883,36.681,36.681,0,0,1,11.349-1.677A8.907,8.907,0,0,1,269.51,217.107Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5786",
    "data-name": "Group 5786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M266.867,203.678a10.065,10.065,0,0,1-2.2-.52l-5.218-1.519-5.214-1.539a10.144,10.144,0,0,1-2.132-.749,9.434,9.434,0,0,1,2.228.393c1.358.314,3.223.8,5.264,1.4s3.872,1.2,5.185,1.668A9.457,9.457,0,0,1,266.867,203.678Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5787",
    "data-name": "Group 5787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M274.352,205.772c.054.144-1.422.761-3.012,1.884s-2.682,2.287-2.8,2.187a9.283,9.283,0,0,1,5.812-4.071Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5788",
    "data-name": "Group 5788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M283.279,223.959a2.116,2.116,0,0,1-.144.786,9.773,9.773,0,0,1-.848,2.008,15.119,15.119,0,0,1-4.948,5.156,29.826,29.826,0,0,1-6.453,3.068,14.9,14.9,0,0,1-2.83.842,18.629,18.629,0,0,1,2.7-1.186,36.993,36.993,0,0,0,6.3-3.158,16.342,16.342,0,0,0,4.917-4.908C282.915,225.038,283.187,223.929,283.279,223.959Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5789",
    "data-name": "Group 5789"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M286.08,252.547a18.9,18.9,0,0,1-.495-3.266c-.224-2.026-.459-4.835-.6-7.944s-.154-5.929-.11-7.968a19.027,19.027,0,0,1,.2-3.3,22.669,22.669,0,0,1,.166,3.3c.051,2.035.125,4.844.263,7.946s.314,5.9.444,7.936A23.005,23.005,0,0,1,286.08,252.547Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5790",
    "data-name": "Group 5790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M303.523,223.361a26.76,26.76,0,0,0-15.2-3.749,7.4,7.4,0,0,1,2.334-.339,20.24,20.24,0,0,1,10.957,2.7A7.4,7.4,0,0,1,303.523,223.361Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5791",
    "data-name": "Group 5791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M309.533,210.23c-.052.048-.335-.23-.887-.539a4.345,4.345,0,0,0-2.388-.554l-.392.027.142-.379a7.46,7.46,0,0,0,.289-.907,10.305,10.305,0,0,0-.153-4.5c.055-.029.369.415.614,1.251A6.62,6.62,0,0,1,306.8,208a6.881,6.881,0,0,1-.324.975l-.251-.35a4.068,4.068,0,0,1,2.6.787C309.373,209.83,309.574,210.2,309.533,210.23Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5798",
    "data-name": "Group 5798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M228.688,243.791l-.151,1.491s-18.37,22.206-19.847,37.467c-1.219,12.6,2.119,108.239,2.119,108.239l60.325-6.743-2.7-138.963Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5793",
    "data-name": "Group 5793"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M254.827,264.785a1.438,1.438,0,0,1,.013.316c0,.237-.01.542-.016.926-.027.848-.065,2.04-.113,3.557-.1,3.089-.309,7.556-.575,13.076-.564,11.038-1.5,26.277-2.7,43.1s-2.4,32.046-3.327,43.058c-.478,5.478-.866,9.923-1.137,13.037-.146,1.511-.26,2.7-.342,3.542l-.1.92a1.453,1.453,0,0,1-.052.312,1.435,1.435,0,0,1,0-.316l.052-.925c.058-.846.14-2.035.244-3.549.232-3.117.563-7.567.972-13.05.814-11.051,1.936-26.261,3.175-43.066,1.2-16.816,2.194-32.048,2.852-43.078.311-5.49.564-9.945.741-13.065.089-1.516.16-2.705.21-3.553.028-.382.05-.687.067-.923A1.494,1.494,0,0,1,254.827,264.785Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5794",
    "data-name": "Group 5794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M246.187,291.8a2.505,2.505,0,0,0-.768,1.223,1.76,1.76,0,0,0,.289,1.421,1.621,1.621,0,0,0,2.745-.8,1.762,1.762,0,0,0-.52-1.354,2.5,2.5,0,0,0-1.3-.618c-.006-.026.139-.107.43-.106a1.83,1.83,0,0,1,1.125.453,2.07,2.07,0,0,1,.748,1.665,2.064,2.064,0,0,1-3.6,1.051,2.068,2.068,0,0,1-.264-1.806,1.833,1.833,0,0,1,.7-.987C246.012,291.782,246.178,291.773,246.187,291.8Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5795",
    "data-name": "Group 5795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M244.375,314a2.515,2.515,0,0,0-.768,1.223,1.762,1.762,0,0,0,.29,1.421,1.62,1.62,0,0,0,2.744-.8,1.762,1.762,0,0,0-.52-1.354,2.5,2.5,0,0,0-1.3-.618c-.006-.025.138-.106.429-.1a1.823,1.823,0,0,1,1.125.453,2.069,2.069,0,0,1,.748,1.664,2.064,2.064,0,0,1-3.6,1.052,2.071,2.071,0,0,1-.264-1.806,1.829,1.829,0,0,1,.7-.987C244.2,313.983,244.367,313.973,244.375,314Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5796",
    "data-name": "Group 5796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M242.183,335.454a2.5,2.5,0,0,0-.768,1.223,1.757,1.757,0,0,0,.29,1.421,1.62,1.62,0,0,0,2.744-.8,1.758,1.758,0,0,0-.52-1.353,2.508,2.508,0,0,0-1.305-.619c-.006-.025.139-.106.43-.105a1.829,1.829,0,0,1,1.125.453,2.069,2.069,0,0,1,.748,1.664,2.064,2.064,0,0,1-3.6,1.052,2.068,2.068,0,0,1-.264-1.806,1.829,1.829,0,0,1,.705-.987C242.008,335.439,242.174,335.43,242.183,335.454Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5797",
    "data-name": "Group 5797"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M240.418,360.014a2.509,2.509,0,0,0-.767,1.223,1.756,1.756,0,0,0,.289,1.421,1.62,1.62,0,0,0,2.744-.8,1.754,1.754,0,0,0-.52-1.353,2.507,2.507,0,0,0-1.3-.619c-.006-.025.139-.106.429-.105a1.83,1.83,0,0,1,1.125.453,2.064,2.064,0,0,1,.748,1.665,2.064,2.064,0,0,1-3.6,1.051,2.071,2.071,0,0,1-.264-1.806,1.829,1.829,0,0,1,.7-.987C240.244,360,240.41,359.99,240.418,360.014Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5856",
    "data-name": "Group 5856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5799",
    "data-name": "Group 5799"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M265.861,166.859c.109.131-.02.493-.506.935a4.6,4.6,0,0,1-2.56,1.063,5.462,5.462,0,0,1-4.107-1.265,6.026,6.026,0,0,1-2.162-4.879,11.239,11.239,0,0,1,1.543-4.628,30.508,30.508,0,0,1,1.9-3.146c1.2-1.719,2.162-2.626,2.463-2.44s-.088,1.427-.843,3.316c-.4.981-.854,2.086-1.345,3.288a11.918,11.918,0,0,0-1.114,3.726,4.028,4.028,0,0,0,1.169,2.983,4.09,4.09,0,0,0,2.477,1.2C264.5,167.223,265.631,166.554,265.861,166.859Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M231.372,141.169a6.426,6.426,0,0,0,4.029-6.805,7.985,7.985,0,0,0-5.259-6.221,10.618,10.618,0,0,0-8.3.734,10.878,10.878,0,0,0-5.275,5.7,8.445,8.445,0,0,0,.775,7.609,8.785,8.785,0,0,0,9.066,3.249,12.418,12.418,0,0,0,7.786-6.167",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5800",
    "data-name": "Group 5800"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M221.879,129.026a3.318,3.318,0,0,1,2.094.111,7.454,7.454,0,0,1,3.952,3.137,14.382,14.382,0,0,1,1.8,4.71,7.42,7.42,0,0,1,.291,2.059,9.343,9.343,0,0,1-.648-1.968,17.387,17.387,0,0,0-1.886-4.519,7.794,7.794,0,0,0-3.633-3.071A14.6,14.6,0,0,0,221.879,129.026Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5801",
    "data-name": "Group 5801"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M230.391,127.776a3.648,3.648,0,0,1,.854,1.394,10.632,10.632,0,0,1,.23,7.762,3.651,3.651,0,0,1-.77,1.442,18.852,18.852,0,0,0,.869-5.33A18.825,18.825,0,0,0,230.391,127.776Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5802",
    "data-name": "Group 5802"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M216.119,135.767c.087-.025.273.78.935,1.888a8.081,8.081,0,0,0,8.525,3.886c1.27-.227,2-.614,2.038-.533a4.25,4.25,0,0,1-1.961.893,7.845,7.845,0,0,1-8.924-4.068A4.256,4.256,0,0,1,216.119,135.767Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5803",
    "data-name": "Group 5803"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M231.792,129.115a1.078,1.078,0,0,1,.333-.234,2.229,2.229,0,0,1,1.09-.225,2.926,2.926,0,0,1,1.566.525,3.359,3.359,0,0,1,1.2,1.625,4.949,4.949,0,0,1-.1,3.6,2.265,2.265,0,0,1-.692.872.916.916,0,0,1-.362.187,2.593,2.593,0,0,0,.92-1.12,5.025,5.025,0,0,0,.041-3.47,3.236,3.236,0,0,0-1.116-1.54,2.872,2.872,0,0,0-1.463-.535A2.713,2.713,0,0,0,231.792,129.115Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M233.268,171.457c-2.971-3.872-6.186-8.807-7.575-13.485a20.5,20.5,0,0,1,.605-14.31c2.4-5.192,7.509-8.839,13.046-10.275a19.463,19.463,0,0,1,14.064,1.37,14.04,14.04,0,0,1,7.476,11.613",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M249.819,135.836c1.208-.117,6.721,1.192,9.754,3.325a12.116,12.116,0,0,1,5.1,11.047c-.277,2.354-2.693,5.553-3.668,7.37a71.629,71.629,0,0,1-5.25,8.382",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5848",
    "data-name": "Group 5848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5847",
    "data-name": "Group 5847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5846",
    "data-name": "Group 5846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5845",
    "data-name": "Group 5845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5844",
    "data-name": "Group 5844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5843",
    "data-name": "Group 5843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5836",
    "data-name": "Group 5836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5835",
    "data-name": "Group 5835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5834",
    "data-name": "Group 5834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M233,152.682a13.52,13.52,0,0,1,14.207-13.229,13.789,13.789,0,0,1,12.831,13.833,141.106,141.106,0,0,1-.438,15c-1.088,6.853-5.494,8.94-7.239,9.505a9.014,9.014,0,0,1-1.872.186h0a.045.045,0,0,0-.046.048l.375,8.1c-.061,5.264-3.615,9.449-8.879,9.449-5.282,0-8.747-4.556-8.783-9.838Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5811",
    "data-name": "Group 5811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5806",
    "data-name": "Group 5806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5805",
    "data-name": "Group 5805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5804",
    "data-name": "Group 5804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M256.839,156.323a1.1,1.1,0,0,1-1.064,1.113,1.056,1.056,0,0,1-1.137-1,1.1,1.1,0,0,1,1.063-1.113A1.055,1.055,0,0,1,256.839,156.323Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5810",
    "data-name": "Group 5810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5809",
    "data-name": "Group 5809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5808",
    "data-name": "Group 5808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5807",
    "data-name": "Group 5807"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M258.18,154.918c-.137.144-.972-.475-2.159-.472-1.185-.014-2.056.6-2.185.452-.063-.065.076-.324.455-.6a3.025,3.025,0,0,1,1.749-.54,2.908,2.908,0,0,1,1.719.555C258.124,154.593,258.248,154.853,258.18,154.918Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5819",
    "data-name": "Group 5819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5814",
    "data-name": "Group 5814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5813",
    "data-name": "Group 5813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5812",
    "data-name": "Group 5812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M245.444,156.323a1.1,1.1,0,0,1-1.064,1.113,1.055,1.055,0,0,1-1.136-1,1.1,1.1,0,0,1,1.062-1.113A1.055,1.055,0,0,1,245.444,156.323Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5818",
    "data-name": "Group 5818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5817",
    "data-name": "Group 5817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5816",
    "data-name": "Group 5816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5815",
    "data-name": "Group 5815"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M246.515,155.139c-.137.144-.974-.474-2.16-.471-1.185-.014-2.056.6-2.185.451-.063-.064.075-.324.456-.6a3.023,3.023,0,0,1,1.749-.539,2.9,2.9,0,0,1,1.718.555C246.457,154.815,246.582,155.075,246.515,155.139Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5823",
    "data-name": "Group 5823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5822",
    "data-name": "Group 5822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5821",
    "data-name": "Group 5821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5820",
    "data-name": "Group 5820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M250.822,163.94a7.848,7.848,0,0,1,1.927-.347c.3-.032.59-.092.641-.3a1.536,1.536,0,0,0-.2-.9q-.428-1.1-.9-2.308a39.553,39.553,0,0,1-2.013-6.036,39.8,39.8,0,0,1,2.494,5.86q.449,1.215.858,2.322a1.749,1.749,0,0,1,.157,1.189.76.76,0,0,1-.5.443,2.072,2.072,0,0,1-.514.072A7.709,7.709,0,0,1,250.822,163.94Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5826",
    "data-name": "Group 5826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5825",
    "data-name": "Group 5825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5824",
    "data-name": "Group 5824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M250.438,177.981s-4.582.376-10.313-3.069c0,0,1.808,6.057,10.415,5.252Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5829",
    "data-name": "Group 5829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5828",
    "data-name": "Group 5828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5827",
    "data-name": "Group 5827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M250.32,166.8a2.138,2.138,0,0,0-1.917-.795,1.954,1.954,0,0,0-1.348.723,1.237,1.237,0,0,0-.094,1.415,1.434,1.434,0,0,0,1.555.393,4.479,4.479,0,0,0,1.517-.9,1.314,1.314,0,0,0,.339-.351.4.4,0,0,0,0-.442",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5833",
    "data-name": "Group 5833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5832",
    "data-name": "Group 5832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5831",
    "data-name": "Group 5831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5830",
    "data-name": "Group 5830"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M247.329,164.761c.193-.011.2,1.277,1.3,2.192s2.474.772,2.484.952c.018.081-.306.25-.885.266a3.207,3.207,0,0,1-2.074-.722,2.792,2.792,0,0,1-1-1.838C247.1,165.073,247.241,164.754,247.329,164.761Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5839",
    "data-name": "Group 5839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5838",
    "data-name": "Group 5838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5837",
    "data-name": "Group 5837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M247.049,153.061c-.117.323-1.3.17-2.695.338-1.4.14-2.518.547-2.7.258-.082-.139.113-.442.567-.755a4.72,4.72,0,0,1,4.112-.453C246.842,152.654,247.1,152.908,247.049,153.061Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5842",
    "data-name": "Group 5842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5841",
    "data-name": "Group 5841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5840",
    "data-name": "Group 5840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M257.744,152.493c-.209.27-1.026-.01-2.01-.023-.982-.048-1.815.181-2.007-.1-.084-.137.047-.407.411-.662a2.909,2.909,0,0,1,3.237.1C257.722,152.084,257.836,152.361,257.744,152.493Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M231.582,157c4.764,1.178,9.5-1.062,13.365-4.191a18.46,18.46,0,0,0,6.568-13.373c.047-1.052.142-3.375-.862-3.6-2.121-.472-2.4-.39-3.734-.024-4.042,1.1-11.375,1.831-13.921,5.358s-3.059,9.281-3.053,13.768",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M245.476,164.21",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5849",
    "data-name": "Group 5849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M260.313,151.709c0-.023.317-.031.856-.2a4.705,4.705,0,0,0,1.985-1.26,5.114,5.114,0,0,0,1.4-3.144,7,7,0,0,0-1-4.119,10.321,10.321,0,0,0-2.985-3.09,18.355,18.355,0,0,0-3.112-1.7c-.928-.407-1.7-.7-2.225-.907l-.608-.241a1,1,0,0,1-.208-.1.935.935,0,0,1,.222.057l.622.205c.537.185,1.315.455,2.256.848a17.545,17.545,0,0,1,3.162,1.681,10.321,10.321,0,0,1,3.055,3.141,7.1,7.1,0,0,1,1.016,4.242,5.209,5.209,0,0,1-1.486,3.23,4.611,4.611,0,0,1-2.068,1.235A2.946,2.946,0,0,1,260.313,151.709Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5850",
    "data-name": "Group 5850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M225.368,146.741c.034-.034.338.285,1,.7a7.119,7.119,0,0,0,3.089.984,10.056,10.056,0,0,0,4.737-.8,33.006,33.006,0,0,0,5.258-2.9,31.24,31.24,0,0,0,4.768-3.653,17,17,0,0,0,3.03-3.817,16.7,16.7,0,0,0,1.611-4.21,3.914,3.914,0,0,1-.128,1.227,11.617,11.617,0,0,1-1.161,3.161,16.355,16.355,0,0,1-3.017,3.983,29.6,29.6,0,0,1-4.821,3.747,31.057,31.057,0,0,1-5.366,2.911,10.1,10.1,0,0,1-4.951.716,6.8,6.8,0,0,1-3.161-1.181,4.621,4.621,0,0,1-.692-.607C225.421,146.841,225.355,146.753,225.368,146.741Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5851",
    "data-name": "Group 5851"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M235.958,135.356a43.468,43.468,0,0,0-5.4,3.763,43.283,43.283,0,0,0-4.381,4.91,5.629,5.629,0,0,1,.917-1.735,18.792,18.792,0,0,1,7.03-6.235A5.608,5.608,0,0,1,235.958,135.356Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5853",
    "data-name": "Group 5853"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M234.759,157.626a3.243,3.243,0,0,0-3.5.472,3.331,3.331,0,0,0,.6,5.223,2.87,2.87,0,0,0,2.134.661",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5852",
    "data-name": "Group 5852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M233.668,161.9c.028.055-.256.266-.788.2a1.564,1.564,0,0,1-.834-.4,1.638,1.638,0,0,1-.181-2.151,1.567,1.567,0,0,1,.757-.533c.512-.155.828.005.809.064-.008.078-.3.073-.666.275a1.3,1.3,0,0,0,.2,2.386C233.357,161.881,233.646,161.826,233.668,161.9Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5854",
    "data-name": "Group 5854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M234.282,172.867c.02.152-.78.477-2.311.362a9.327,9.327,0,0,1-5.733-2.906,9.067,9.067,0,0,1-2.228-4.074,9.728,9.728,0,0,1,.277-5.353,10.082,10.082,0,0,1,3.448-4.852,13.316,13.316,0,0,1,5.808-2.228,27.264,27.264,0,0,0,5.3-1.264,16.775,16.775,0,0,0,9.367-9.018,20.3,20.3,0,0,0,1.476-5.606c.162-1.387.2-2.189.389-2.212.165-.022.474.747.624,2.224a15.732,15.732,0,0,1-.766,6.243,17.2,17.2,0,0,1-5.3,7.81,17.943,17.943,0,0,1-4.848,2.93,27.128,27.128,0,0,1-5.752,1.452,11.352,11.352,0,0,0-4.772,1.718,7.915,7.915,0,0,0-2.707,3.6,7.805,7.805,0,0,0-.425,4.1,7.541,7.541,0,0,0,1.506,3.317,9.549,9.549,0,0,0,4.539,3.117C233.464,172.628,234.268,172.666,234.282,172.867Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5855",
    "data-name": "Group 5855"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M224.24,151.853c0-.375,1.973-.617,5.068-.982a33.47,33.47,0,0,0,11.369-3.035,16.585,16.585,0,0,0,4.942-3.8,13.978,13.978,0,0,0,2.561-4.388c.986-2.785.68-4.755,1.081-4.826.16-.036.464.408.689,1.323a9.542,9.542,0,0,1,.009,3.979,13.325,13.325,0,0,1-2.471,5.416,16.6,16.6,0,0,1-5.612,4.611,22.688,22.688,0,0,1-6.785,2.191,30.967,30.967,0,0,1-5.694.37C226.177,152.608,224.238,152.2,224.24,151.853Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5858",
    "data-name": "Group 5858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5857",
    "data-name": "Group 5857"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M234.217,227.685l-2.77,34.426a2.626,2.626,0,0,0,2.688,2.835l25.785-.7a2.626,2.626,0,0,0,2.541-2.354l3.487-33.729a2.626,2.626,0,0,0-2.611-2.9h-26.5A2.626,2.626,0,0,0,234.217,227.685Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M251.835,230.7a1.553,1.553,0,1,1-1.552-1.553A1.552,1.552,0,0,1,251.835,230.7Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M233.833,240.769s-3.528,1.047-4.149,1.7a16.427,16.427,0,0,1-2.94,1.794l-2.655.709-3.714,11.192,22.492.718s6.2-4.4,5.427-4.885-3.172-.077-4.215,1c-1.635,1.689-4.313-.676-4.313-.676s11.164-2.279,12.094-3.419,2.016-1.3,1.4-2.442-5.271-.489-6.822-.489a43.05,43.05,0,0,0-5.117.652s6.968-2.459,7.5-2.752c1.4-.765-.057-2.3-1.945-1.85-1.69.4-8.038,2.648-9.124,2.485s-4.031-.489-4.031-.489Z",
    fill: "#ffbe9d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5982",
    "data-name": "Group 5982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5862",
    "data-name": "Group 5862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5860",
    "data-name": "Group 5860"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    "data-name": "Rectangle 575",
    width: 67.187,
    height: 9.232,
    transform: "translate(79.225 400.694)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5861",
    "data-name": "Group 5861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M146.526,410.041H79.11v-9.462h67.416Zm-67.186-.23H146.3v-9H79.34Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5864",
    "data-name": "Group 5864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5863",
    "data-name": "Group 5863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M85.454,406.853l9.671,47.71h35.783l9.349-44.637Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5866",
    "data-name": "Group 5866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5865",
    "data-name": "Group 5865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M85.454,450.05l5.158,7.092h43.494l6.151-7.092Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5869",
    "data-name": "Group 5869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5868",
    "data-name": "Group 5868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5867",
    "data-name": "Group 5867"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M110.295,408.247c-.132,0-.3-22.1-.378-49.362s-.032-49.368.1-49.368.3,22.1.379,49.366S110.427,408.246,110.295,408.247Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5872",
    "data-name": "Group 5872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5871",
    "data-name": "Group 5871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5870",
    "data-name": "Group 5870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M125.262,352.934a2.377,2.377,0,0,1-.181.514c-.157.376-.356.849-.6,1.431l-.438,1.03q-.208.584-.447,1.255t-.518,1.439c-.18.51-.321,1.067-.5,1.641a66.817,66.817,0,0,0-1.879,8.226,99.99,99.99,0,0,0-1.04,10.287,138.536,138.536,0,0,0,.531,18.791c.216,2.4.433,4.337.593,5.676.069.627.125,1.138.169,1.543a2.253,2.253,0,0,1,.027.543,2.323,2.323,0,0,1-.122-.529c-.068-.4-.153-.909-.259-1.532-.216-1.332-.485-3.267-.745-5.667a123.77,123.77,0,0,1-.673-18.848,93.936,93.936,0,0,1,1.084-10.337,62.254,62.254,0,0,1,1.991-8.253c.187-.574.34-1.13.532-1.64l.556-1.435.486-1.247c.166-.376.335-.712.479-1.018.278-.568.5-1.031.683-1.4A2.312,2.312,0,0,1,125.262,352.934Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5875",
    "data-name": "Group 5875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5874",
    "data-name": "Group 5874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5873",
    "data-name": "Group 5873"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M123.544,335.058a4.607,4.607,0,0,1-.214.729q-.261.767-.7,2.055-.234.673-.514,1.481-.25.826-.541,1.785c-.392,1.279-.848,2.732-1.253,4.367l-.674,2.555q-.3,1.347-.63,2.8c-.469,1.924-.808,4.014-1.241,6.2-.74,4.39-1.392,9.243-1.842,14.362-.425,5.123-.61,10.018-.675,14.472-.013,4.453.043,8.467.226,11.831.06,1.684.168,3.2.255,4.54s.161,2.487.246,3.425q.1,1.359.164,2.165a4.349,4.349,0,0,1,.025.759,4.575,4.575,0,0,1-.12-.749q-.1-.8-.255-2.157c-.113-.937-.225-2.086-.327-3.423s-.244-2.857-.326-4.542c-.226-3.368-.318-7.388-.329-11.852.041-4.464.213-9.373.639-14.51.451-5.133,1.119-10,1.885-14.4.446-2.188.8-4.281,1.288-6.207q.342-1.449.659-2.8.368-1.331.706-2.555c.426-1.634.906-3.085,1.324-4.36l.58-1.776.554-1.471.785-2.027A4.349,4.349,0,0,1,123.544,335.058Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5878",
    "data-name": "Group 5878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5877",
    "data-name": "Group 5877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5876",
    "data-name": "Group 5876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M106.046,412.157a1.022,1.022,0,0,1-.038-.259c-.017-.2-.038-.448-.064-.76-.047-.7-.113-1.684-.2-2.927-.162-2.579-.391-6.248-.674-10.766-.583-9.089-1.427-21.646-2.956-35.454-.782-6.9-1.688-13.461-2.63-19.406-.5-2.967-.955-5.791-1.471-8.418-.472-2.634-.982-5.075-1.45-7.3-.442-2.233-.934-4.233-1.33-6s-.766-3.278-1.08-4.512c-.3-1.21-.53-2.162-.7-2.848-.07-.3-.126-.55-.17-.744a1.037,1.037,0,0,1-.042-.258,1.062,1.062,0,0,1,.089.245c.057.191.128.432.216.732.189.68.452,1.626.785,2.827.343,1.227.746,2.733,1.16,4.495s.937,3.757,1.4,5.988c.49,2.226,1.019,4.665,1.509,7.3.533,2.627,1,5.452,1.516,8.421.968,5.949,1.888,12.512,2.671,19.424,1.531,13.823,2.321,26.391,2.818,35.487.247,4.548.418,8.231.522,10.776.046,1.246.082,2.226.108,2.932.006.313.011.564.016.763A1.143,1.143,0,0,1,106.046,412.157Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5880",
    "data-name": "Group 5880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5879",
    "data-name": "Group 5879"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M109.747,320.142c-.292-3.131-3.456-5.493-6.6-5.526a10.393,10.393,0,0,0-8,4.342,25.024,25.024,0,0,0-3.852,8.549c-2.117,7.377-3.275,15.128-2.37,22.749s4,15.125,9.467,20.51c.889.876,2.041,1.751,3.261,1.491a3.937,3.937,0,0,0,1.721-1.063A50.91,50.91,0,0,0,119.9,332.48c-.085-2.9-.465-5.914-2.07-8.329s-5.346-4.978-8.079-4.009",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5900",
    "data-name": "Group 5900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5882",
    "data-name": "Group 5882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5881",
    "data-name": "Group 5881"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M86.265,295.062l-4.429,8.021c-.1.187-.24.4-.453.414-.233.019-.407-.2-.534-.4l-11.71-17.972,2.7-1.528Z",
    fill: "#e8505b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5885",
    "data-name": "Group 5885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5884",
    "data-name": "Group 5884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5883",
    "data-name": "Group 5883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M86.265,295.062l-4.429,8.021c-.1.187-.24.4-.453.414-.233.019-.407-.2-.534-.4l-11.71-17.972,2.7-1.528Z",
    fill: "#0f3576"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5887",
    "data-name": "Group 5887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5886",
    "data-name": "Group 5886"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M110.017,309.516,70.073,285.945a1.861,1.861,0,0,1-.973-.981c-.159-.591.285-1.161.711-1.6a27.53,27.53,0,0,1,21.347-8.386,24.387,24.387,0,0,1,19.3,12c3.855,6.888,3.983,16-.439,22.536",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5890",
    "data-name": "Group 5890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5889",
    "data-name": "Group 5889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5888",
    "data-name": "Group 5888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M75.83,278.421a2.237,2.237,0,0,1,.523-.065c.344-.017.853-.079,1.51-.072a29.882,29.882,0,0,1,5.542.44,32.392,32.392,0,0,1,25.854,23.394,29.93,29.93,0,0,1,.99,5.471,10.947,10.947,0,0,1,.061,1.165,1.952,1.952,0,0,1-.308.871,6.692,6.692,0,0,0,.062-2.016,34.165,34.165,0,0,0-1.13-5.4,32.632,32.632,0,0,0-25.589-23.154,34,34,0,0,0-5.484-.587C76.557,278.441,75.832,278.464,75.83,278.421Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5893",
    "data-name": "Group 5893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5892",
    "data-name": "Group 5892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5891",
    "data-name": "Group 5891"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M104.611,293.247a9.58,9.58,0,0,1-2.019.918c-1.273.5-3.052,1.143-5.041,1.775s-3.812,1.134-5.141,1.459a9.573,9.573,0,0,1-2.179.415,10.863,10.863,0,0,1,2.088-.741l5.087-1.589,5.072-1.638A10.846,10.846,0,0,1,104.611,293.247Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5896",
    "data-name": "Group 5896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5895",
    "data-name": "Group 5895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5894",
    "data-name": "Group 5894"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M98.321,276.351a27.955,27.955,0,0,1,.226,8.93,27.782,27.782,0,0,1-.232-4.462A27.81,27.81,0,0,1,98.321,276.351Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5899",
    "data-name": "Group 5899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5898",
    "data-name": "Group 5898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5897",
    "data-name": "Group 5897"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M69.724,285.5a18.026,18.026,0,0,1,2.9-1.021c1.814-.559,4.342-1.267,7.159-1.947s5.391-1.2,7.262-1.527a17.829,17.829,0,0,1,3.048-.412,21.582,21.582,0,0,1-2.982.744c-1.85.412-4.4.984-7.216,1.661s-5.344,1.332-7.179,1.807A21.292,21.292,0,0,1,69.724,285.5Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5918",
    "data-name": "Group 5918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5902",
    "data-name": "Group 5902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5901",
    "data-name": "Group 5901"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M93.168,313.348c-3.435-2.6-7.068-3.118-11.376-2.948a34.785,34.785,0,0,0-12.451,3.213c-6.736,2.95-13.067,7.3-17.091,13.453s-5.425,14.3-2.412,21.009A2.994,2.994,0,0,0,51.2,349.73a3.257,3.257,0,0,0,2.254-.172c7.661-2.5,15.376-5.022,22.42-8.936s13.455-9.353,17.235-16.47a14.149,14.149,0,0,0,1.814-5.466,6.79,6.79,0,0,0-1.757-5.338",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5905",
    "data-name": "Group 5905"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5904",
    "data-name": "Group 5904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5903",
    "data-name": "Group 5903"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M93.236,312.54a2.8,2.8,0,0,1-.551.224l-1.6.552-1.163.387c-.421.152-.87.341-1.358.529-.969.393-2.094.784-3.279,1.359l-1.878.856c-.652.3-1.3.67-1.991,1.021-1.388.682-2.793,1.554-4.289,2.437a67.752,67.752,0,0,0-16.9,14.869c-1.067,1.371-2.11,2.654-2.964,3.944-.436.638-.885,1.236-1.267,1.844L54.9,342.316c-.722,1.1-1.253,2.169-1.766,3.08-.249.459-.493.881-.7,1.279l-.533,1.1c-.308.624-.558,1.128-.752,1.521a2.881,2.881,0,0,1-.292.519,2.719,2.719,0,0,1,.2-.557c.173-.4.4-.922.672-1.563l.5-1.125c.193-.406.426-.835.665-1.3.492-.927,1.006-2.01,1.712-3.129l1.068-1.78c.375-.617.819-1.223,1.251-1.871.845-1.308,1.882-2.608,2.947-4A65.616,65.616,0,0,1,76.89,319.53c1.513-.879,2.934-1.743,4.339-2.414.7-.346,1.355-.709,2.014-1l1.9-.832c1.2-.558,2.339-.93,3.321-1.3.494-.177.95-.354,1.377-.493l1.179-.349,1.636-.468A2.778,2.778,0,0,1,93.236,312.54Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5908",
    "data-name": "Group 5908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5907",
    "data-name": "Group 5907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5906",
    "data-name": "Group 5906"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M66.4,327.072a80.575,80.575,0,0,1-8.357,2.693A80.621,80.621,0,0,1,49.548,332a80.606,80.606,0,0,1,8.358-2.692A80.683,80.683,0,0,1,66.4,327.072Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5911",
    "data-name": "Group 5911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5910",
    "data-name": "Group 5910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5909",
    "data-name": "Group 5909"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M66.053,345.514a13.334,13.334,0,0,1-.184-2.6c-.044-1.61-.051-3.835.017-6.291s.2-4.679.335-6.284a13.323,13.323,0,0,1,.329-2.589,14.974,14.974,0,0,1,.009,2.608c-.055,1.764-.121,3.908-.194,6.278s-.113,4.514-.157,6.278A15,15,0,0,1,66.053,345.514Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5914",
    "data-name": "Group 5914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5913",
    "data-name": "Group 5913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5912",
    "data-name": "Group 5912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M81.85,337.466c-.132.009-.552-4.513-.938-10.1s-.593-10.123-.461-10.132.552,4.512.938,10.1S81.982,337.457,81.85,337.466Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5917",
    "data-name": "Group 5917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5916",
    "data-name": "Group 5916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5915",
    "data-name": "Group 5915"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M62.186,316.8a14.919,14.919,0,0,1,2.679-.081c1.652.012,3.932.06,6.448.143s4.8.186,6.445.284a14.86,14.86,0,0,1,2.668.257,14.832,14.832,0,0,1-2.675.081c-1.652-.011-3.934-.06-6.453-.143s-4.8-.186-6.448-.284A14.74,14.74,0,0,1,62.186,316.8Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5921",
    "data-name": "Group 5921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5920",
    "data-name": "Group 5920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5919",
    "data-name": "Group 5919"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    d: "M100.105,371.817a2.365,2.365,0,0,1-.057-.535c-.018-.4-.042-.911-.07-1.536-.061-1.335-.074-3.269-.023-5.657s.206-5.232.493-8.379c.311-3.145.761-6.594,1.406-10.186.662-3.591,1.456-6.981,2.273-10.038.841-3.051,1.691-5.774,2.493-8.031s1.489-4.069,2.016-5.3c.247-.577.449-1.046.608-1.418a2.326,2.326,0,0,1,.242-.482,2.351,2.351,0,0,1-.152.517l-.524,1.449c-.473,1.25-1.118,3.074-1.869,5.34s-1.573,4.988-2.387,8.035c-.791,3.054-1.569,6.433-2.229,10.011-.642,3.579-1.1,7.013-1.438,10.146-.31,3.134-.507,5.966-.594,8.347s-.132,4.311-.129,5.644c-.008.626-.014,1.135-.019,1.537A2.25,2.25,0,0,1,100.105,371.817Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5924",
    "data-name": "Group 5924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5923",
    "data-name": "Group 5923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5922",
    "data-name": "Group 5922"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M102.212,345.664a10.937,10.937,0,0,1-1.593,1.748c-1.034,1.031-2.5,2.414-4.175,3.882s-3.239,2.742-4.4,3.632a10.865,10.865,0,0,1-1.942,1.35,12.389,12.389,0,0,1,1.728-1.612l4.295-3.73,4.258-3.768A12.315,12.315,0,0,1,102.212,345.664Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5927",
    "data-name": "Group 5927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5926",
    "data-name": "Group 5926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5925",
    "data-name": "Group 5925"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M114.856,355.848a18.723,18.723,0,0,1-1.7-2.351l-3.947-5.76c-1.531-2.167-2.916-4.126-4.03-5.7a18.749,18.749,0,0,1-1.614-2.409,16.306,16.306,0,0,1,1.885,2.206c1.108,1.408,2.59,3.39,4.152,5.634s2.9,4.322,3.838,5.85A16.251,16.251,0,0,1,114.856,355.848Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5930",
    "data-name": "Group 5930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5929",
    "data-name": "Group 5929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5928",
    "data-name": "Group 5928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M108.233,323.818c.071.111-4.129,2.938-9.38,6.314s-9.568,6.024-9.64,5.913,4.128-2.938,9.381-6.315S108.161,323.707,108.233,323.818Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5933",
    "data-name": "Group 5933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5932",
    "data-name": "Group 5932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5931",
    "data-name": "Group 5931"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M120.075,336.6a78.442,78.442,0,0,1-6.352-5.87,78.656,78.656,0,0,1-6.019-6.213,78.292,78.292,0,0,1,6.353,5.87A78.118,78.118,0,0,1,120.075,336.6Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5951",
    "data-name": "Group 5951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5935",
    "data-name": "Group 5935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5934",
    "data-name": "Group 5934"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M123.053,336.343l3.606-.3a17.839,17.839,0,0,0,7.281-2.229,28.84,28.84,0,0,1,3.393-1.7c4.458-1.79,9.431-1.47,14.229-1.71a58.91,58.91,0,0,0,22.634-5.788,2.2,2.2,0,0,0,.986-.9c.741-1.349-.635-2.551-1.819-3.28-6.074-3.743-12.257-7.533-19.145-9.391s-14.708-1.544-20.585,2.5c-6.9,4.748-9.414,14.5-10.58,22.794",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5938",
    "data-name": "Group 5938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5937",
    "data-name": "Group 5937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5936",
    "data-name": "Group 5936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M175.264,323.276a3.583,3.583,0,0,1-.612-.285l-1.709-.895c-1.482-.779-3.616-1.93-6.312-3.223a59.038,59.038,0,0,0-9.77-3.765,32.25,32.25,0,0,0-12.663-1.026,21.641,21.641,0,0,0-11.544,4.957,25.667,25.667,0,0,0-6.011,8.443c-1.267,2.7-2.048,5-2.616,6.574q-.4,1.131-.642,1.819a3.522,3.522,0,0,1-.252.625,3.524,3.524,0,0,1,.161-.655c.14-.467.325-1.081.556-1.848a60.216,60.216,0,0,1,2.485-6.657,25.555,25.555,0,0,1,6.027-8.631,21.9,21.9,0,0,1,11.774-5.1,32.237,32.237,0,0,1,12.843,1.076,56.856,56.856,0,0,1,9.8,3.886c2.687,1.337,4.8,2.534,6.253,3.364l1.666.974A3.54,3.54,0,0,1,175.264,323.276Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5941",
    "data-name": "Group 5941"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5940",
    "data-name": "Group 5940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5939",
    "data-name": "Group 5939"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M166.6,327.928c-.074.109-4.79-2.941-10.531-6.813s-10.339-7.1-10.265-7.21,4.789,2.94,10.532,6.814S166.679,327.818,166.6,327.928Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5944",
    "data-name": "Group 5944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5943",
    "data-name": "Group 5943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5942",
    "data-name": "Group 5942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M161.575,313.657a11.464,11.464,0,0,1-3.433.617,11.612,11.612,0,0,1-3.5-.045,22.6,22.6,0,0,1,3.46-.353A22.773,22.773,0,0,1,161.575,313.657Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5947",
    "data-name": "Group 5947"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5946",
    "data-name": "Group 5946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5945",
    "data-name": "Group 5945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M140.933,310.967a9.148,9.148,0,0,1-1.547,2.416,10.341,10.341,0,0,1-1.959,2.227,9.131,9.131,0,0,1,1.547-2.417A10.379,10.379,0,0,1,140.933,310.967Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5950",
    "data-name": "Group 5950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5949",
    "data-name": "Group 5949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5948",
    "data-name": "Group 5948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M145.158,330.7a12.441,12.441,0,0,1-2.27-1.23c-1.362-.827-3.2-2.038-5.17-3.466s-3.7-2.779-4.947-3.768a13.906,13.906,0,0,1-1.958-1.679,13.629,13.629,0,0,1,2.161,1.408L138,325.621c1.961,1.424,3.762,2.673,5.073,3.57A15.37,15.37,0,0,1,145.158,330.7Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5969",
    "data-name": "Group 5969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5953",
    "data-name": "Group 5953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5952",
    "data-name": "Group 5952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M128.362,351.661c-3.439-.908-7.538,2.437-8.247,5.923s.6,7.05,2.129,10.261a52.345,52.345,0,0,0,14.221,18.607,35.167,35.167,0,0,0,21.744,8.005c-1.453-6.753.385-13.808-.425-20.667a26.885,26.885,0,0,0-23.811-23.574c-2.2-.237-4.735-.582-5.611,1.445",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5956",
    "data-name": "Group 5956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5955",
    "data-name": "Group 5955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5954",
    "data-name": "Group 5954"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M158.209,394.457a2.339,2.339,0,0,1-.489-.228,8.846,8.846,0,0,1-1.286-.864,13.4,13.4,0,0,1-3.4-4.541c-.548-1.064-1.161-2.22-1.76-3.5l-1.85-4.09a39.56,39.56,0,0,0-2.273-4.371,34.224,34.224,0,0,0-3.129-4.255c-2.355-2.766-4.881-5.159-7.071-7.444a48.6,48.6,0,0,1-5.391-6.469,23.75,23.75,0,0,1-2.634-5.031,15.336,15.336,0,0,1-.459-1.475,2.265,2.265,0,0,1-.109-.528c.045-.013.239.7.742,1.935a25.965,25.965,0,0,0,2.739,4.908,51.191,51.191,0,0,0,5.429,6.352c2.2,2.262,4.74,4.648,7.119,7.442a33.92,33.92,0,0,1,3.164,4.32,38.863,38.863,0,0,1,2.275,4.434l1.809,4.105c.577,1.274,1.173,2.442,1.7,3.512a13.9,13.9,0,0,0,3.215,4.554C157.558,394.089,158.238,394.41,158.209,394.457Z",
    fill: "#263238",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5959",
    "data-name": "Group 5959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5958",
    "data-name": "Group 5958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5957",
    "data-name": "Group 5957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M140.426,388.845a10.346,10.346,0,0,1,.316-2.315c.269-1.416.711-3.36,1.307-5.478s1.235-4.008,1.745-5.356a10.241,10.241,0,0,1,.939-2.139,12.659,12.659,0,0,1-.619,2.249c-.426,1.372-1.01,3.267-1.6,5.375s-1.084,4.03-1.437,5.423A12.436,12.436,0,0,1,140.426,388.845Z",
    fill: "#263238",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5962",
    "data-name": "Group 5962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5961",
    "data-name": "Group 5961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5960",
    "data-name": "Group 5960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M157.558,372.27a14.381,14.381,0,0,1-2.423-.557c-1.482-.388-3.528-.917-5.8-1.43s-4.353-.912-5.858-1.2a14.235,14.235,0,0,1-2.427-.535,11.672,11.672,0,0,1,2.481.2c1.523.2,3.619.549,5.909,1.064s4.332,1.1,5.794,1.572A11.63,11.63,0,0,1,157.558,372.27Z",
    fill: "#263238",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5965",
    "data-name": "Group 5965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5964",
    "data-name": "Group 5964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5963",
    "data-name": "Group 5963"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M127.665,377.086a13.991,13.991,0,0,1,.372-2.679c.3-1.642.784-3.9,1.427-6.365s1.327-4.671,1.866-6.251a14.109,14.109,0,0,1,.984-2.518,16.361,16.361,0,0,1-.661,2.619c-.455,1.6-1.084,3.814-1.726,6.271s-1.173,4.693-1.559,6.314A16.441,16.441,0,0,1,127.665,377.086Z",
    fill: "#263238",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5968",
    "data-name": "Group 5968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5967",
    "data-name": "Group 5967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5966",
    "data-name": "Group 5966"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M149.668,357.825c-.014.131-4.307-.216-9.588-.776s-9.552-1.121-9.538-1.252,4.306.216,9.589.776S149.682,357.693,149.668,357.825Z",
    fill: "#263238",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5972",
    "data-name": "Group 5972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5971",
    "data-name": "Group 5971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5970",
    "data-name": "Group 5970"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M146.523,409.887c0,.132-15.091.239-33.7.239s-33.706-.107-33.706-.239,15.088-.239,33.706-.239S146.523,409.755,146.523,409.887Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5975",
    "data-name": "Group 5975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5974",
    "data-name": "Group 5974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5973",
    "data-name": "Group 5973"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M136.024,429.308c0,.132-10.169.239-22.709.239s-22.71-.107-22.71-.239,10.166-.24,22.71-.24S136.024,429.176,136.024,429.308Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5978",
    "data-name": "Group 5978"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5977",
    "data-name": "Group 5977"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5976",
    "data-name": "Group 5976"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M135.629,432.084c0,.132-9.991.24-22.313.24S91,432.216,91,432.084s9.988-.239,22.314-.239S135.629,431.952,135.629,432.084Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5981",
    "data-name": "Group 5981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5980",
    "data-name": "Group 5980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5979",
    "data-name": "Group 5979"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M136.42,427.019c0,.132-10.517.239-23.488.239s-23.491-.107-23.491-.239,10.515-.239,23.491-.239S136.42,426.887,136.42,427.019Z",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5992",
    "data-name": "Group 5992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5983",
    "data-name": "Group 5983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M394.017,400.992a10.63,10.63,0,0,1,5.51,6.239,18.752,18.752,0,0,1,.733,8.452c-.62,5.485-3.736,11.023-7.091,15.407-4.62-4.031-5.684-11.063-6-14.664-.5-5.692,2.056-16.281,6.848-15.434",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5984",
    "data-name": "Group 5984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M398.927,440.706a9.068,9.068,0,0,1,2.3-8.811,12.047,12.047,0,0,1,8.658-3.41,5.072,5.072,0,0,1,4.015,1.465,3.876,3.876,0,0,1,.345,3.915,7.873,7.873,0,0,1-2.695,3.069c-3.81,2.8-8.01,4.8-12.622,3.772",
    stroke: "rgba(0,0,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5986",
    "data-name": "Group 5986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5985",
    "data-name": "Group 5985"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M392.835,456.9a4.232,4.232,0,0,1,.137-1.152c.128-.733.334-1.79.629-3.089a38.9,38.9,0,0,1,3.473-9.828,19.507,19.507,0,0,1,7.1-7.607,12.754,12.754,0,0,1,2.916-1.264,3.548,3.548,0,0,1,1.144-.215A27.162,27.162,0,0,0,404.4,435.6a20.476,20.476,0,0,0-6.779,7.529,45.121,45.121,0,0,0-3.591,9.639A34.983,34.983,0,0,1,392.835,456.9Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5988",
    "data-name": "Group 5988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5987",
    "data-name": "Group 5987"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M392.987,409.286a11.246,11.246,0,0,1,.183,1.9c.079,1.227.164,3.005.245,5.2.162,4.395.287,10.471.26,17.182s-.2,12.789-.4,17.182c-.1,2.2-.2,3.974-.287,5.2a11.294,11.294,0,0,1-.2,1.9,11.314,11.314,0,0,1-.042-1.912c.024-1.337.054-3.09.091-5.205.088-4.394.194-10.464.223-17.171s-.029-12.774-.08-17.169c-.019-2.115-.035-3.868-.047-5.206A11.256,11.256,0,0,1,392.987,409.286Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5989",
    "data-name": "Group 5989"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M390.4,443.649a21.213,21.213,0,0,0-11.252-15.782c-1.527-.772-3.532-1.3-4.825-.176s-1.054,3.192-.466,4.8a18.124,18.124,0,0,0,16.424,11.6",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5991",
    "data-name": "Group 5991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5990",
    "data-name": "Group 5990"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M379.588,433.024a3.85,3.85,0,0,1,1.032.412,8.945,8.945,0,0,1,1.15.612,14.839,14.839,0,0,1,1.456.933,22.353,22.353,0,0,1,3.4,2.952,23.87,23.87,0,0,1,5.475,9.5,22.379,22.379,0,0,1,.85,4.423,15.035,15.035,0,0,1,.078,1.727,8.982,8.982,0,0,1-.048,1.3,3.8,3.8,0,0,1-.161,1.1c-.121-.006.015-1.583-.3-4.081a24.888,24.888,0,0,0-.959-4.3,25.221,25.221,0,0,0-5.35-9.283,24.924,24.924,0,0,0-3.242-2.987C380.965,433.8,379.533,433.132,379.588,433.024Z",
    fill: "#263238"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportHome);
export default __webpack_public_path__ + "static/media/Report_Home.e381134552373d54c8d34b36e32801ba.svg";
export { ForwardRef as ReactComponent };